import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  accountStatus: UserStatus;
  accountType: AccountType;
  avatar?: Maybe<ImageAsset>;
  banner?: Maybe<ImageAsset>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Remaining messaging credits */
  messageCredits?: Maybe<Scalars['Float']['output']>;
  metadata: AccountMetadata;
  mobile?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  referralCode: Scalars['String']['output'];
  referrals?: Maybe<PaginatedResult>;
  salesCount: Scalars['Float']['output'];
  tags: Array<Tag>;
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
  wallets: Array<Wallet>;
};


export type AccountAvatarArgs = {
  height?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};


export type AccountBannerArgs = {
  height?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};


export type AccountReferralsArgs = {
  options?: InputMaybe<PaginationOptions>;
};

export type AccountMetadata = {
  __typename?: 'AccountMetadata';
  onboarding: OnboardingUnion;
  subscribedProfiles: Array<Scalars['String']['output']>;
};

/** NSFW.app account types */
export enum AccountType {
  ADMIRER = 'ADMIRER',
  CREATOR = 'CREATOR',
  FAN = 'FAN'
}

export type Approval = {
  __typename?: 'Approval';
  account?: Maybe<Account>;
  app: Scalars['String']['output'];
  applicationUrl: Scalars['String']['output'];
  approvalId: Scalars['String']['output'];
  approvalStatus: ApprovalStatus;
  createdAt: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  requestedAt?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

/** User approval states */
export enum ApprovalStatus {
  APPROVED = 'APPROVED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED',
  SUBMITTED = 'SUBMITTED'
}

/** The audience for a message */
export enum Audience {
  ALL = 'ALL',
  NONE = 'NONE',
  SUBSCRIBERS = 'SUBSCRIBERS'
}

export type AuthenticateWithPrivyInput = {
  /** Privy Access Token */
  accessToken: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeUsernameInput = {
  username: Scalars['String']['input'];
};

export type ClaimReferralRewardInput = {
  referralId: Scalars['String']['input'];
  rewardAddress: Scalars['String']['input'];
};

export type Comment = {
  __typename?: 'Comment';
  author: Profile;
  commentId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  post: Post;
  postId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type ConfirmEmailInput = {
  token: Scalars['String']['input'];
};

export type ConfirmPaymentInput = {
  orderId: Scalars['String']['input'];
  transactionHash: Scalars['String']['input'];
};

export type ConfirmWithdrawalInput = {
  orderId: Scalars['String']['input'];
  transactionHash: Scalars['String']['input'];
};

export type CreateAccountFromEoaInput = {
  address: Scalars['String']['input'];
  chainId: Scalars['Int']['input'];
  nonce: Scalars['String']['input'];
  /** Wallet provider */
  provider: WalletProvider;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  signature: Scalars['String']['input'];
  source: Scalars['String']['input'];
  /** Wallet brand name eg. MetaMask, Ardent */
  title: Scalars['String']['input'];
};

export type CreateAccountInput = {
  accountType: AccountType;
  email: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirm: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateAccountResult = {
  __typename?: 'CreateAccountResult';
  /** Current user status */
  accountStatus: UserStatus;
  /** A signed JSON web token */
  token?: Maybe<Scalars['String']['output']>;
};

export type CreateCommentInput = {
  comment: Scalars['String']['input'];
  postId: Scalars['String']['input'];
};

export type CreatePlanInput = {
  currencyCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  subscriptionSettingId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreatePostInput = {
  postTo: PostTarget;
  postType: PostType;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateReportInput = {
  /** owner of the reported item */
  profileId: Scalars['String']['input'];
  reason: ReportReason;
  /** post#, comment#, profile# */
  reportedItemId: Scalars['String']['input'];
  reportedItemType: ReportItem;
};

export type CreateSaleInput = {
  amount: Scalars['String']['input'];
  chainId: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
  product: ProductInput;
  signer: Scalars['String']['input'];
  tokenSymbol: TokenSymbol;
};

export type CreateThreadInput = {
  postTo: PostTarget;
};

export type CreateWithdrawalInput = {
  amount: Scalars['String']['input'];
  chainId: Scalars['Int']['input'];
  recipient: Scalars['String']['input'];
};

export type CreatorOnboarding = {
  __typename?: 'CreatorOnboarding';
  approvals: Array<Approval>;
  createdSubscriptionPlan: Scalars['Boolean']['output'];
  firstWithdrawal: Scalars['Boolean']['output'];
  hasLinkedWallet: Scalars['Boolean']['output'];
  setupMessaging: Scalars['Boolean']['output'];
  updateBio: Scalars['Boolean']['output'];
  updatedBio: Scalars['Boolean']['output'];
  uploadedAvatar: Scalars['Boolean']['output'];
  uploadedFirstPost: Scalars['Boolean']['output'];
};

export type CryptoCurrency = {
  __typename?: 'CryptoCurrency';
  contract: Scalars['String']['output'];
  symbol: TokenSymbol;
};

export type CryptoPayment = {
  __typename?: 'CryptoPayment';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  paymentId: Scalars['String']['output'];
  recipient: Scalars['String']['output'];
  signer: Scalars['String']['output'];
  status: PaymentStatus;
  token: CryptoCurrency;
  transactionHash?: Maybe<Scalars['String']['output']>;
};

export type Currency = {
  __typename?: 'Currency';
  currencyCode: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DonationProduct = {
  __typename?: 'DonationProduct';
  creator?: Maybe<Profile>;
  type: ProductType;
};

export type Earnings = {
  __typename?: 'Earnings';
  analyticsInterval: Scalars['String']['output'];
  availableToWithdraw?: Maybe<Scalars['Float']['output']>;
  sales: Sales;
  withdrawals?: Maybe<Scalars['Float']['output']>;
};

export type EarningsByMonth = {
  __typename?: 'EarningsByMonth';
  items: Array<EarningsItem>;
};

export type EarningsByProductSummary = {
  __typename?: 'EarningsByProductSummary';
  count: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type EarningsItem = {
  __typename?: 'EarningsItem';
  exclusivePosts?: Maybe<EarningsByProductSummary>;
  label: Scalars['String']['output'];
  messages?: Maybe<EarningsByProductSummary>;
  subscriptions?: Maybe<EarningsByProductSummary>;
  tips?: Maybe<EarningsByProductSummary>;
  total: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

export type ExchangeAmount = {
  __typename?: 'ExchangeAmount';
  amount: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  chainId: Scalars['Float']['output'];
  from: ExchangeAmount;
  spotPrice: Scalars['String']['output'];
  to: ExchangeAmount;
};

export type ExchangeRateInput = {
  amount: Scalars['String']['input'];
  chainId: Scalars['Int']['input'];
  from: Scalars['String']['input'];
  to: TokenSymbol;
};

export type ExclusivePostProduct = {
  __typename?: 'ExclusivePostProduct';
  creator?: Maybe<Profile>;
  post?: Maybe<Post>;
  type: ProductType;
};

export type FanOnboarding = {
  __typename?: 'FanOnboarding';
  firstExclusivePost: Scalars['Boolean']['output'];
  firstFollow: Scalars['Boolean']['output'];
  firstLike: Scalars['Boolean']['output'];
  firstSubscription: Scalars['Boolean']['output'];
  firstTip: Scalars['Boolean']['output'];
  hasLinkedWallet: Scalars['Boolean']['output'];
  updateBio: Scalars['Boolean']['output'];
  updatedBio: Scalars['Boolean']['output'];
  uploadedAvatar: Scalars['Boolean']['output'];
};

/** [NSFW+] feed types */
export enum FeedType {
  FOLLOWING = 'FOLLOWING',
  /** Lastest posts */
  LATEST = 'LATEST',
  /** Liked posts */
  LIKED = 'LIKED',
  /** Public conversations */
  THREADS_PUBLIC = 'THREADS_PUBLIC'
}

export type ImageAsset = {
  __typename?: 'ImageAsset';
  aspectRatio: Scalars['Float']['output'];
  fallbackUrl: Scalars['String']['output'];
  formats?: Maybe<Array<ResizedAsset>>;
  originalHeight: Scalars['Int']['output'];
  originalWidth: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export enum Interval {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS'
}

export type IsEmailAvailableInput = {
  email: Scalars['String']['input'];
};

export type IsUsernameAvailableInput = {
  username: Scalars['String']['input'];
};

export type IsUsernameValidInput = {
  username: Scalars['String']['input'];
};

export type IsValidUsernameResult = {
  __typename?: 'IsValidUsernameResult';
  invalidCharacters?: Maybe<Array<Scalars['String']['output']>>;
  isValid: Scalars['Boolean']['output'];
};

export type LinkWalletInput = {
  /** ETH address */
  address: Scalars['String']['input'];
  chainId: Scalars['Int']['input'];
  nonce: Scalars['String']['input'];
  /** Wallet provider */
  provider: WalletProvider;
  signature: Scalars['String']['input'];
  /** Wallet brand name eg. MetaMask, Ardent */
  title: Scalars['String']['input'];
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginResult = {
  __typename?: 'LoginResult';
  /** A signed JSON web token */
  token: Scalars['String']['output'];
};

export type Media = ImageAsset | VideoAsset;

export type MessagePack = {
  __typename?: 'MessagePack';
  credits: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  messagePackId: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MessagePackProduct = {
  __typename?: 'MessagePackProduct';
  creator?: Maybe<Profile>;
  pack?: Maybe<MessagePack>;
  type: ProductType;
};

export type MessageSettings = {
  __typename?: 'MessageSettings';
  audience?: Maybe<Audience>;
  rate?: Maybe<Scalars['Float']['output']>;
  rateId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type MessagingPreferencesInput = {
  audience: Audience;
  rate?: InputMaybe<Scalars['Float']['input']>;
};

export type MobileVerificationResult = {
  __typename?: 'MobileVerificationResult';
  /** ISO Date string */
  expiresAt: Scalars['String']['output'];
  /** verification# for later reference */
  verificationId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addComment: Comment;
  archivePlan: Scalars['Boolean']['output'];
  authenticateFromEOA: CreateAccountResult;
  authenticateWithPrivy: CreateAccountResult;
  changeEmail: Scalars['String']['output'];
  changePassword: Scalars['String']['output'];
  changeUsername: Account;
  claimReferralReward: Referral;
  clearNotifications: Scalars['Boolean']['output'];
  confirmEmail: Scalars['String']['output'];
  confirmPayment: CryptoPayment;
  confirmWithdrawal: Order;
  createAccount: CreateAccountResult;
  createPlan: Plan;
  createPost: Post;
  createReport: Scalars['Boolean']['output'];
  createSale: Order;
  createSubscriptionSetting: PlanOption;
  createTag: Tag;
  createThread: Post;
  createWithdrawal: Order;
  deleteAccount: Scalars['String']['output'];
  deleteNotification: Notification;
  deletePost: Scalars['Boolean']['output'];
  deletePostMedia: Scalars['Boolean']['output'];
  discardPost: Scalars['Boolean']['output'];
  followProfile: Profile;
  linkWallet: Scalars['Boolean']['output'];
  login: LoginResult;
  messagingPreferences: Profile;
  orderPostMedia: Post;
  publishPost: Scalars['Boolean']['output'];
  recordPayment: CryptoPayment;
  recoverAccount: Scalars['String']['output'];
  requestApproval: Approval;
  resolveApproval: Approval;
  sendMessage: Scalars['Float']['output'];
  sendMobileVerification: MobileVerificationResult;
  sendUpdateMobileVerification: MobileVerificationResult;
  setEmail: Scalars['String']['output'];
  setPassword: LoginResult;
  startApplication: Scalars['Boolean']['output'];
  toggleLikePost: Post;
  toggleNotificationRead: Notification;
  unfollowProfile: Profile;
  updateAvatar: Account;
  updateBanner: Account;
  updateBio: Profile;
  updateDisplayName: Profile;
  updateEmail: Scalars['String']['output'];
  updateMobile: Account;
  updateOrder: Order;
  updatePlan: Plan;
  updatePost: Post;
  updatePostTags: Post;
  updatePronouns: Profile;
  updateTags: Profile;
  verifyMobile: Scalars['Boolean']['output'];
};


export type MutationAddCommentArgs = {
  input: CreateCommentInput;
};


export type MutationArchivePlanArgs = {
  planId: Scalars['String']['input'];
};


export type MutationAuthenticateFromEoaArgs = {
  input: CreateAccountFromEoaInput;
};


export type MutationAuthenticateWithPrivyArgs = {
  input: AuthenticateWithPrivyInput;
};


export type MutationChangeUsernameArgs = {
  input: ChangeUsernameInput;
};


export type MutationClaimReferralRewardArgs = {
  input: ClaimReferralRewardInput;
};


export type MutationConfirmEmailArgs = {
  input: ConfirmEmailInput;
};


export type MutationConfirmPaymentArgs = {
  input: ConfirmPaymentInput;
};


export type MutationConfirmWithdrawalArgs = {
  input: ConfirmWithdrawalInput;
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreatePlanArgs = {
  input: CreatePlanInput;
};


export type MutationCreatePostArgs = {
  input: CreatePostInput;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationCreateSaleArgs = {
  input: CreateSaleInput;
};


export type MutationCreateSubscriptionSettingArgs = {
  input: PlanOptionInput;
};


export type MutationCreateTagArgs = {
  input: TagInput;
};


export type MutationCreateThreadArgs = {
  input: CreateThreadInput;
};


export type MutationCreateWithdrawalArgs = {
  input: CreateWithdrawalInput;
};


export type MutationDeleteNotificationArgs = {
  notificationId: Scalars['String']['input'];
};


export type MutationDeletePostArgs = {
  postId: Scalars['String']['input'];
};


export type MutationDeletePostMediaArgs = {
  ordinal: Scalars['Int']['input'];
  postId: Scalars['String']['input'];
};


export type MutationDiscardPostArgs = {
  postId: Scalars['String']['input'];
};


export type MutationFollowProfileArgs = {
  profileId: Scalars['String']['input'];
};


export type MutationLinkWalletArgs = {
  input: LinkWalletInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationMessagingPreferencesArgs = {
  input: MessagingPreferencesInput;
};


export type MutationOrderPostMediaArgs = {
  input: OrderPostMediaInput;
};


export type MutationPublishPostArgs = {
  input: PublishPostInput;
};


export type MutationRecordPaymentArgs = {
  input: RecordPaymentInput;
};


export type MutationRecoverAccountArgs = {
  input: RecoverAccountInput;
};


export type MutationResolveApprovalArgs = {
  uid: Scalars['String']['input'];
};


export type MutationSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationSendMobileVerificationArgs = {
  input: SendMobileVerificationInput;
};


export type MutationSendUpdateMobileVerificationArgs = {
  input: SendMobileVerificationInput;
};


export type MutationSetEmailArgs = {
  input: SetEmailInput;
};


export type MutationSetPasswordArgs = {
  input: SetPasswordInput;
};


export type MutationStartApplicationArgs = {
  input: StartApplicationInput;
};


export type MutationToggleLikePostArgs = {
  input: ToggleLikePostInput;
};


export type MutationToggleNotificationReadArgs = {
  notificationId: Scalars['String']['input'];
};


export type MutationUnfollowProfileArgs = {
  profileId: Scalars['String']['input'];
};


export type MutationUpdateAvatarArgs = {
  image: Scalars['Upload']['input'];
};


export type MutationUpdateBannerArgs = {
  image: Scalars['Upload']['input'];
};


export type MutationUpdateBioArgs = {
  bio: Scalars['String']['input'];
};


export type MutationUpdateDisplayNameArgs = {
  displayName: Scalars['String']['input'];
};


export type MutationUpdateEmailArgs = {
  input: UpdateEmailInput;
};


export type MutationUpdateMobileArgs = {
  input: UpdateMobileInput;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};


export type MutationUpdatePlanArgs = {
  input: UpdatePlanInput;
};


export type MutationUpdatePostArgs = {
  input: UpdatePostInput;
};


export type MutationUpdatePostTagsArgs = {
  postId: Scalars['String']['input'];
  tagIds: Array<Scalars['String']['input']>;
};


export type MutationUpdatePronounsArgs = {
  pronouns: Scalars['String']['input'];
};


export type MutationUpdateTagsArgs = {
  tagIds: Array<Scalars['String']['input']>;
};


export type MutationVerifyMobileArgs = {
  input: VerifyMobileInput;
};

export type NsfwSubscription = {
  __typename?: 'NSFWSubscription';
  createdAt: Scalars['String']['output'];
  creator?: Maybe<Profile>;
  expiresAt: Scalars['String']['output'];
  order: Order;
  plan: Plan;
  status: SubscriptionStatus;
  subscriber?: Maybe<Profile>;
};

export type Notification = {
  __typename?: 'Notification';
  actor?: Maybe<Profile>;
  createdAt: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  notificationId: Scalars['String']['output'];
  notificationType: NotificationType;
  paymentAmount?: Maybe<Scalars['String']['output']>;
  paymentCurrency?: Maybe<Scalars['String']['output']>;
  paymentProductType?: Maybe<ProductType>;
  post?: Maybe<Post>;
  postId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  withdrawalAmount?: Maybe<Scalars['String']['output']>;
  withdrawalCurrency?: Maybe<Scalars['String']['output']>;
  withdrawalTxn?: Maybe<Scalars['String']['output']>;
};

/** Notification types */
export enum NotificationType {
  MESSAGING_BALANCE_CREDIT = 'MESSAGING_BALANCE_CREDIT',
  POST_COMMENT = 'POST_COMMENT',
  POST_LIKE = 'POST_LIKE',
  POST_PROCESSING = 'POST_PROCESSING',
  POST_PUBLISHED = 'POST_PUBLISHED',
  POST_PURCHASED = 'POST_PURCHASED',
  PROFILE_FOLLOWED = 'PROFILE_FOLLOWED',
  REFERRAL_ELIGIBLE = 'REFERRAL_ELIGIBLE',
  REFERRAL_REWARD_ISSUED = 'REFERRAL_REWARD_ISSUED',
  WITHDRAWAL_CONFIRMED = 'WITHDRAWAL_CONFIRMED'
}

export type OnboardingUnion = CreatorOnboarding | FanOnboarding;

export type Order = {
  __typename?: 'Order';
  chainId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currencyCode: Scalars['String']['output'];
  customer?: Maybe<Profile>;
  modifers?: Maybe<Array<OrderModiferUnion>>;
  orderId: Scalars['String']['output'];
  payments: Array<CryptoPayment>;
  price: Scalars['String']['output'];
  products: Array<ProductUnion>;
  recipient: Scalars['String']['output'];
  signer: Scalars['String']['output'];
  status: OrderStatus;
  token: CryptoCurrency;
  /** Cost after any modifers */
  total: Scalars['String']['output'];
  type: OrderType;
};

export type OrderFilter = {
  byOrderType?: InputMaybe<OrderType>;
  byProductType?: InputMaybe<ProductType>;
  status?: InputMaybe<Array<OrderStatus>>;
};

export type OrderModiferUnion = PlatformFee;

export type OrderPostMediaInput = {
  order: Array<Scalars['Int']['input']>;
  postId: Scalars['String']['input'];
};

/** NSFW.app order status */
export enum OrderStatus {
  CANCELED = 'CANCELED',
  CHECKOUT = 'CHECKOUT',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  FLAGGED = 'FLAGGED',
  STARTED = 'STARTED'
}

export enum OrderType {
  CREDIT = 'CREDIT',
  SALE = 'SALE',
  WITHDRAWAL = 'WITHDRAWAL'
}

export type Pageable = Comment | NsfwSubscription | Notification | Order | Post | Profile | Referral | Tag;

export type PaginatedResult = {
  __typename?: 'PaginatedResult';
  cursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<Pageable>>;
};

export type PaginationOptions = {
  lastRecord?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SortBy>;
  sortDirection?: InputMaybe<SortDirection>;
};

export enum PaymentStatus {
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  FLAGGED = 'FLAGGED',
  NOT_SEEN = 'NOT_SEEN',
  PENDING = 'PENDING',
  SUBMITTED = 'SUBMITTED'
}

export type Plan = {
  __typename?: 'Plan';
  colour: Scalars['String']['output'];
  currency: Currency;
  description: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  interval: Interval;
  planId: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type PlanOption = {
  __typename?: 'PlanOption';
  duration: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  interval: Interval;
  title: Scalars['String']['output'];
};

export type PlanOptionInput = {
  duration: Scalars['Int']['input'];
  interval: Interval;
  title: Scalars['String']['input'];
};

export type PlatformFee = {
  __typename?: 'PlatformFee';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type Post = {
  __typename?: 'Post';
  asset?: Maybe<Array<PostAsset>>;
  commentCount: Scalars['Int']['output'];
  comments: PaginatedResult;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isLiked: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  isSubscribed: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  likeCount: Scalars['Int']['output'];
  permalink: Scalars['String']['output'];
  postId: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  profile?: Maybe<Profile>;
  profileId: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['String']['output']>;
  status: PostStatus;
  tags?: Maybe<Array<Tag>>;
  type: PostType;
};


export type PostCommentsArgs = {
  options?: InputMaybe<PaginationOptions>;
};

export type PostAsset = {
  __typename?: 'PostAsset';
  media: Media;
  ordinal: Scalars['Float']['output'];
};

/** [nsfw] post filters */
export enum PostFilter {
  ALL = 'ALL',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

/** [nsfw] post statuses */
export enum PostStatus {
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  /** Post has been flagged by community or moderator */
  FLAGGED = 'FLAGGED',
  PROCESSING = 'PROCESSING',
  /** Creator has published post */
  PUBLISHED = 'PUBLISHED',
  /** Post scheduled for publishing at a future date */
  SCHEDULED = 'SCHEDULED'
}

/** [nsfw] post targets */
export enum PostTarget {
  FEED = 'FEED',
  STORY = 'STORY',
  THREAD_PUBLIC = 'THREAD_PUBLIC',
  THREAD_SUBSCRIBERS_ONLY = 'THREAD_SUBSCRIBERS_ONLY'
}

/** [nsfw] post types */
export enum PostType {
  EXCLUSIVE = 'EXCLUSIVE',
  SUBSCRIPTION = 'SUBSCRIPTION',
  TEASER = 'TEASER',
  THREAD = 'THREAD'
}

export type ProductInput = {
  /** MessagePack# */
  messagePackId?: InputMaybe<Scalars['String']['input']>;
  /** A active Plan# */
  planId?: InputMaybe<Scalars['String']['input']>;
  /** A published Post# */
  postId?: InputMaybe<Scalars['String']['input']>;
  /** Creator Profile# */
  profileId?: InputMaybe<Scalars['String']['input']>;
  type: ProductType;
};

/** [nsfw] products */
export enum ProductType {
  DONATION = 'DONATION',
  EXCLUSIVE_POST = 'EXCLUSIVE_POST',
  MESSAGE_PACK = 'MESSAGE_PACK',
  MESSAGING_PAYMENT = 'MESSAGING_PAYMENT',
  SUBSCRIPTION = 'SUBSCRIPTION',
  TIP = 'TIP',
  WITHDRAWAL = 'WITHDRAWAL'
}

export type ProductUnion = DonationProduct | ExclusivePostProduct | MessagePackProduct | SubscriptionProduct | TipProduct | WithdrawalProduct;

export type Profile = {
  __typename?: 'Profile';
  accountType: AccountType;
  activeSubscriberCount: Scalars['Float']['output'];
  avatar?: Maybe<ImageAsset>;
  banner?: Maybe<ImageAsset>;
  bio?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  followers?: Maybe<PaginatedResult>;
  followersCount: Scalars['Float']['output'];
  following?: Maybe<PaginatedResult>;
  followingCount: Scalars['Float']['output'];
  isFollowing: Scalars['Boolean']['output'];
  messaging?: Maybe<MessageSettings>;
  posts: PaginatedResult;
  postsCount: Scalars['Float']['output'];
  profileId: Scalars['String']['output'];
  pronouns?: Maybe<Scalars['String']['output']>;
  referralUrl: Scalars['String']['output'];
  tags: Array<Tag>;
  username: Scalars['String']['output'];
};


export type ProfileAvatarArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileBannerArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileFollowersArgs = {
  options?: InputMaybe<PaginationOptions>;
};


export type ProfileFollowingArgs = {
  options?: InputMaybe<PaginationOptions>;
};


export type ProfilePostsArgs = {
  filter?: InputMaybe<PostFilter>;
  options?: InputMaybe<PaginationOptions>;
};

export type PublishPostInput = {
  postId: Scalars['String']['input'];
  publishAt?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  creatorSubscriptions: PaginatedResult;
  earnings: Earnings;
  exchangeRate: ExchangeRate;
  feed: PaginatedResult;
  isEmailAvailable: Scalars['Boolean']['output'];
  isUsernameAvailable: Scalars['Boolean']['output'];
  isUsernameValid: IsValidUsernameResult;
  isVerificationValid: Scalars['Boolean']['output'];
  listUnconfiguredPlans: Array<PlanOption>;
  /** Returns current logged in user */
  me: Account;
  messagePacks: Array<MessagePack>;
  /** Returns a paginated list of active subscriptions for the curent authenticated user */
  mySubscriptions: PaginatedResult;
  nonce: Scalars['String']['output'];
  notifications: PaginatedResult;
  orders: PaginatedResult;
  sales: PaginatedResult;
  scheduledPosts: PaginatedResult;
  search: PaginatedResult;
  seasonOneReferrals: SeasonReferrals;
  subscribers: PaginatedResult;
  suggestions: Array<Profile>;
  tags: PaginatedResult;
  unreadNotificationsCount: Scalars['Float']['output'];
  viewCreatorPlans: Array<Plan>;
  viewOrder: Order;
  viewPost: Post;
  viewProfile: Profile;
};


export type QueryCreatorSubscriptionsArgs = {
  filter?: InputMaybe<SubscriptionStatusFilter>;
  options?: InputMaybe<PaginationOptions>;
};


export type QueryExchangeRateArgs = {
  input: ExchangeRateInput;
};


export type QueryFeedArgs = {
  options?: InputMaybe<PaginationOptions>;
  type: FeedType;
};


export type QueryIsEmailAvailableArgs = {
  input: IsEmailAvailableInput;
};


export type QueryIsUsernameAvailableArgs = {
  input: IsUsernameAvailableInput;
};


export type QueryIsUsernameValidArgs = {
  input: IsUsernameValidInput;
};


export type QueryIsVerificationValidArgs = {
  token: Scalars['String']['input'];
};


export type QueryMySubscriptionsArgs = {
  filter?: InputMaybe<SubscriptionStatusFilter>;
  options?: InputMaybe<PaginationOptions>;
};


export type QueryNotificationsArgs = {
  options?: InputMaybe<PaginationOptions>;
};


export type QueryOrdersArgs = {
  filter?: InputMaybe<OrderFilter>;
  options?: InputMaybe<PaginationOptions>;
};


export type QuerySalesArgs = {
  options?: InputMaybe<PaginationOptions>;
};


export type QueryScheduledPostsArgs = {
  options?: InputMaybe<PaginationOptions>;
};


export type QuerySearchArgs = {
  options?: InputMaybe<PaginationOptions>;
  query: Scalars['String']['input'];
};


export type QuerySubscribersArgs = {
  filter?: InputMaybe<SubscriptionStatusFilter>;
  options?: InputMaybe<PaginationOptions>;
};


export type QueryTagsArgs = {
  input: TagFilter;
  options?: InputMaybe<PaginationOptions>;
};


export type QueryViewCreatorPlansArgs = {
  creatorId: Scalars['String']['input'];
};


export type QueryViewOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryViewPostArgs = {
  postId: Scalars['String']['input'];
};


export type QueryViewProfileArgs = {
  profileId?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type RecordPaymentInput = {
  orderId: Scalars['String']['input'];
  transactionHash: Scalars['String']['input'];
};

export type RecoverAccountInput = {
  email: Scalars['String']['input'];
};

export type Referral = {
  __typename?: 'Referral';
  completedAt?: Maybe<Scalars['String']['output']>;
  profile: Profile;
  referralId: Scalars['String']['output'];
  rewardAddress?: Maybe<Scalars['String']['output']>;
  rewardAmountUSD: Scalars['String']['output'];
  rewards?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionHash?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/** NSFW.app reportable item types */
export enum ReportItem {
  COMMENT = 'COMMENT',
  POST = 'POST',
  PROFILE = 'PROFILE'
}

/** NSFW.app report reason options */
export enum ReportReason {
  HARASSEMENT = 'HARASSEMENT',
  HATE_SPEECH = 'HATE_SPEECH',
  ILLEGAL = 'ILLEGAL',
  INAPPROPRIATE = 'INAPPROPRIATE',
  INTELLECTUAL_PROPERTY_VIOLATION = 'INTELLECTUAL_PROPERTY_VIOLATION',
  SPAM = 'SPAM'
}

export type ResizedAsset = {
  __typename?: 'ResizedAsset';
  fallbackUrl: Scalars['String']['output'];
  format: ResizedAssetFormat;
  height?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export enum ResizedAssetFormat {
  DESKTOP_FULL = 'DESKTOP_FULL',
  LARGE_CARD = 'LARGE_CARD',
  LARGE_THUMB = 'LARGE_THUMB',
  MOBILE_FULL = 'MOBILE_FULL',
  SMALL_THUMB = 'SMALL_THUMB',
  XSMALL_THUMB = 'XSMALL_THUMB'
}

export type Sales = {
  __typename?: 'Sales';
  byMonth: EarningsByMonth;
  exclusivePosts: EarningsByProductSummary;
  messages: EarningsByProductSummary;
  subscriptions: EarningsByProductSummary;
  tips: EarningsByProductSummary;
  total: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

export type SeasonReferrals = {
  __typename?: 'SeasonReferrals';
  rewardsRemaining: Scalars['String']['output'];
  rewardsTotal: Scalars['String']['output'];
};

export type SendMessageInput = {
  messageId: Scalars['String']['input'];
  messageSettingId: Scalars['String']['input'];
};

export type SendMobileVerificationInput = {
  mobile: Scalars['String']['input'];
};

export type SetEmailInput = {
  email: Scalars['String']['input'];
};

export type SetPasswordInput = {
  password: Scalars['String']['input'];
  passwordConfirm: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** [NSFW+] feed sort by */
export enum SortBy {
  CREATED_AT = 'CREATED_AT',
  LIKES = 'LIKES',
  POPULAR = 'POPULAR'
}

/** [NSFW+] feed sort direction */
export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type StartApplicationInput = {
  type: AccountType;
};

export type SubscriptionProduct = {
  __typename?: 'SubscriptionProduct';
  creator?: Maybe<Profile>;
  plan: Plan;
  subscription?: Maybe<NsfwSubscription>;
  type: ProductType;
};

/** NSFW.app subscription statuses */
export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED'
}

export enum SubscriptionStatusFilter {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED'
}

export type Tag = {
  __typename?: 'Tag';
  emoji?: Maybe<Scalars['String']['output']>;
  key: TagKey;
  slug: Scalars['String']['output'];
  tagId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TagFilter = {
  key: TagKey;
  query: Scalars['String']['input'];
};

export type TagInput = {
  emoji?: InputMaybe<Scalars['String']['input']>;
  key: TagKey;
  value: Scalars['String']['input'];
};

export enum TagKey {
  MEDIA = 'MEDIA',
  POST = 'POST',
  PROFILE = 'PROFILE'
}

export type TipProduct = {
  __typename?: 'TipProduct';
  creator?: Maybe<Profile>;
  post?: Maybe<Post>;
  type: ProductType;
};

export type ToggleLikePostInput = {
  liked: Scalars['Boolean']['input'];
  postId: Scalars['String']['input'];
};

/** [nsfw] tokens accepted */
export enum TokenSymbol {
  BNB = 'BNB',
  BUSD = 'BUSD',
  CURVE = 'CURVE',
  DAI = 'DAI',
  MATIC = 'MATIC',
  NSFW = 'NSFW',
  OP = 'OP',
  PORNROCKET = 'PORNROCKET',
  SUSHI = 'SUSHI',
  USDC = 'USDC',
  USDT = 'USDT',
  WBNB = 'WBNB',
  WBTC = 'WBTC',
  WETH = 'WETH',
  WMATIC = 'WMATIC'
}

export type UpdateEmailInput = {
  confirmEmail: Scalars['String']['input'];
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type UpdateMobileInput = {
  mobile: Scalars['String']['input'];
  verificationId: Scalars['String']['input'];
};

export type UpdateOrderInput = {
  amount: Scalars['String']['input'];
  chainId: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  signer: Scalars['String']['input'];
  tokenSymbol: TokenSymbol;
};

export type UpdatePlanInput = {
  description: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type UpdatePostInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['String']['input'];
  postType: PostType;
  price?: InputMaybe<Scalars['Float']['input']>;
};

/** NSFW.app user account statuses */
export enum UserStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  DOCUMENTS_REJECTED = 'DOCUMENTS_REJECTED',
  INACTIVE = 'INACTIVE',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  PENDING_DOCUMENTS = 'PENDING_DOCUMENTS',
  REJECTED = 'REJECTED',
  SUSPENDED = 'SUSPENDED'
}

export type VerifyMobileInput = {
  mobile: Scalars['String']['input'];
  verificationCode: Scalars['Int']['input'];
  verificationId: Scalars['String']['input'];
};

export type VideoAsset = {
  __typename?: 'VideoAsset';
  aspectRatio: Scalars['Float']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  fallbackUrl: Scalars['String']['output'];
  formats?: Maybe<Array<ResizedAsset>>;
  originalHeight: Scalars['Int']['output'];
  originalWidth: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type Wallet = {
  __typename?: 'Wallet';
  address: Scalars['String']['output'];
  /** Is authorised for use on our platform */
  isLinked: Scalars['Boolean']['output'];
  provider: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum WalletProvider {
  BROWSER_EXTENSION = 'BROWSER_EXTENSION',
  INJECTED = 'INJECTED',
  WALLETCONNECT = 'WALLETCONNECT'
}

export type WithdrawalProduct = {
  __typename?: 'WithdrawalProduct';
  creator?: Maybe<Profile>;
  type: ProductType;
};

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<RefType extends Record<string, unknown>> = ResolversObject<{
  Media: ( ImageAsset ) | ( VideoAsset );
  OnboardingUnion: ( CreatorOnboarding ) | ( FanOnboarding );
  OrderModiferUnion: ( PlatformFee );
  Pageable: ( Comment ) | ( NsfwSubscription ) | ( Notification ) | ( Omit<Order, 'modifers' | 'products'> & { modifers?: Maybe<Array<RefType['OrderModiferUnion']>>, products: Array<RefType['ProductUnion']> } ) | ( Post ) | ( Profile ) | ( Referral ) | ( Tag );
  ProductUnion: ( DonationProduct ) | ( ExclusivePostProduct ) | ( MessagePackProduct ) | ( SubscriptionProduct ) | ( TipProduct ) | ( WithdrawalProduct );
}>;


/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  Account: ResolverTypeWrapper<Account>;
  AccountMetadata: ResolverTypeWrapper<Omit<AccountMetadata, 'onboarding'> & { onboarding: ResolversTypes['OnboardingUnion'] }>;
  AccountType: AccountType;
  Approval: ResolverTypeWrapper<Approval>;
  ApprovalStatus: ApprovalStatus;
  Audience: Audience;
  AuthenticateWithPrivyInput: AuthenticateWithPrivyInput;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  ChangeUsernameInput: ChangeUsernameInput;
  ClaimReferralRewardInput: ClaimReferralRewardInput;
  Comment: ResolverTypeWrapper<Comment>;
  ConfirmEmailInput: ConfirmEmailInput;
  ConfirmPaymentInput: ConfirmPaymentInput;
  ConfirmWithdrawalInput: ConfirmWithdrawalInput;
  CreateAccountFromEOAInput: CreateAccountFromEoaInput;
  CreateAccountInput: CreateAccountInput;
  CreateAccountResult: ResolverTypeWrapper<CreateAccountResult>;
  CreateCommentInput: CreateCommentInput;
  CreatePlanInput: CreatePlanInput;
  CreatePostInput: CreatePostInput;
  CreateReportInput: CreateReportInput;
  CreateSaleInput: CreateSaleInput;
  CreateThreadInput: CreateThreadInput;
  CreateWithdrawalInput: CreateWithdrawalInput;
  CreatorOnboarding: ResolverTypeWrapper<CreatorOnboarding>;
  CryptoCurrency: ResolverTypeWrapper<CryptoCurrency>;
  CryptoPayment: ResolverTypeWrapper<CryptoPayment>;
  Currency: ResolverTypeWrapper<Currency>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DonationProduct: ResolverTypeWrapper<DonationProduct>;
  Earnings: ResolverTypeWrapper<Earnings>;
  EarningsByMonth: ResolverTypeWrapper<EarningsByMonth>;
  EarningsByProductSummary: ResolverTypeWrapper<EarningsByProductSummary>;
  EarningsItem: ResolverTypeWrapper<EarningsItem>;
  ExchangeAmount: ResolverTypeWrapper<ExchangeAmount>;
  ExchangeRate: ResolverTypeWrapper<ExchangeRate>;
  ExchangeRateInput: ExchangeRateInput;
  ExclusivePostProduct: ResolverTypeWrapper<ExclusivePostProduct>;
  FanOnboarding: ResolverTypeWrapper<FanOnboarding>;
  FeedType: FeedType;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  ImageAsset: ResolverTypeWrapper<ImageAsset>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Interval: Interval;
  IsEmailAvailableInput: IsEmailAvailableInput;
  IsUsernameAvailableInput: IsUsernameAvailableInput;
  IsUsernameValidInput: IsUsernameValidInput;
  IsValidUsernameResult: ResolverTypeWrapper<IsValidUsernameResult>;
  LinkWalletInput: LinkWalletInput;
  LoginInput: LoginInput;
  LoginResult: ResolverTypeWrapper<LoginResult>;
  Media: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Media']>;
  MessagePack: ResolverTypeWrapper<MessagePack>;
  MessagePackProduct: ResolverTypeWrapper<MessagePackProduct>;
  MessageSettings: ResolverTypeWrapper<MessageSettings>;
  MessagingPreferencesInput: MessagingPreferencesInput;
  MobileVerificationResult: ResolverTypeWrapper<MobileVerificationResult>;
  Mutation: ResolverTypeWrapper<{}>;
  NSFWSubscription: ResolverTypeWrapper<NsfwSubscription>;
  Notification: ResolverTypeWrapper<Notification>;
  NotificationType: NotificationType;
  OnboardingUnion: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OnboardingUnion']>;
  Order: ResolverTypeWrapper<Omit<Order, 'modifers' | 'products'> & { modifers?: Maybe<Array<ResolversTypes['OrderModiferUnion']>>, products: Array<ResolversTypes['ProductUnion']> }>;
  OrderFilter: OrderFilter;
  OrderModiferUnion: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderModiferUnion']>;
  OrderPostMediaInput: OrderPostMediaInput;
  OrderStatus: OrderStatus;
  OrderType: OrderType;
  Pageable: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Pageable']>;
  PaginatedResult: ResolverTypeWrapper<Omit<PaginatedResult, 'items'> & { items?: Maybe<Array<ResolversTypes['Pageable']>> }>;
  PaginationOptions: PaginationOptions;
  PaymentStatus: PaymentStatus;
  Plan: ResolverTypeWrapper<Plan>;
  PlanOption: ResolverTypeWrapper<PlanOption>;
  PlanOptionInput: PlanOptionInput;
  PlatformFee: ResolverTypeWrapper<PlatformFee>;
  Post: ResolverTypeWrapper<Post>;
  PostAsset: ResolverTypeWrapper<Omit<PostAsset, 'media'> & { media: ResolversTypes['Media'] }>;
  PostFilter: PostFilter;
  PostStatus: PostStatus;
  PostTarget: PostTarget;
  PostType: PostType;
  ProductInput: ProductInput;
  ProductType: ProductType;
  ProductUnion: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ProductUnion']>;
  Profile: ResolverTypeWrapper<Profile>;
  PublishPostInput: PublishPostInput;
  Query: ResolverTypeWrapper<{}>;
  RecordPaymentInput: RecordPaymentInput;
  RecoverAccountInput: RecoverAccountInput;
  Referral: ResolverTypeWrapper<Referral>;
  ReportItem: ReportItem;
  ReportReason: ReportReason;
  ResizedAsset: ResolverTypeWrapper<ResizedAsset>;
  ResizedAssetFormat: ResizedAssetFormat;
  Sales: ResolverTypeWrapper<Sales>;
  SeasonReferrals: ResolverTypeWrapper<SeasonReferrals>;
  SendMessageInput: SendMessageInput;
  SendMobileVerificationInput: SendMobileVerificationInput;
  SetEmailInput: SetEmailInput;
  SetPasswordInput: SetPasswordInput;
  SortBy: SortBy;
  SortDirection: SortDirection;
  StartApplicationInput: StartApplicationInput;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SubscriptionProduct: ResolverTypeWrapper<SubscriptionProduct>;
  SubscriptionStatus: SubscriptionStatus;
  SubscriptionStatusFilter: SubscriptionStatusFilter;
  Tag: ResolverTypeWrapper<Tag>;
  TagFilter: TagFilter;
  TagInput: TagInput;
  TagKey: TagKey;
  TipProduct: ResolverTypeWrapper<TipProduct>;
  ToggleLikePostInput: ToggleLikePostInput;
  TokenSymbol: TokenSymbol;
  UpdateEmailInput: UpdateEmailInput;
  UpdateMobileInput: UpdateMobileInput;
  UpdateOrderInput: UpdateOrderInput;
  UpdatePlanInput: UpdatePlanInput;
  UpdatePostInput: UpdatePostInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']['output']>;
  UserStatus: UserStatus;
  VerifyMobileInput: VerifyMobileInput;
  VideoAsset: ResolverTypeWrapper<VideoAsset>;
  Wallet: ResolverTypeWrapper<Wallet>;
  WalletProvider: WalletProvider;
  WithdrawalProduct: ResolverTypeWrapper<WithdrawalProduct>;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  Account: Account;
  AccountMetadata: Omit<AccountMetadata, 'onboarding'> & { onboarding: ResolversParentTypes['OnboardingUnion'] };
  Approval: Approval;
  AuthenticateWithPrivyInput: AuthenticateWithPrivyInput;
  Boolean: Scalars['Boolean']['output'];
  ChangeUsernameInput: ChangeUsernameInput;
  ClaimReferralRewardInput: ClaimReferralRewardInput;
  Comment: Comment;
  ConfirmEmailInput: ConfirmEmailInput;
  ConfirmPaymentInput: ConfirmPaymentInput;
  ConfirmWithdrawalInput: ConfirmWithdrawalInput;
  CreateAccountFromEOAInput: CreateAccountFromEoaInput;
  CreateAccountInput: CreateAccountInput;
  CreateAccountResult: CreateAccountResult;
  CreateCommentInput: CreateCommentInput;
  CreatePlanInput: CreatePlanInput;
  CreatePostInput: CreatePostInput;
  CreateReportInput: CreateReportInput;
  CreateSaleInput: CreateSaleInput;
  CreateThreadInput: CreateThreadInput;
  CreateWithdrawalInput: CreateWithdrawalInput;
  CreatorOnboarding: CreatorOnboarding;
  CryptoCurrency: CryptoCurrency;
  CryptoPayment: CryptoPayment;
  Currency: Currency;
  DateTime: Scalars['DateTime']['output'];
  DonationProduct: DonationProduct;
  Earnings: Earnings;
  EarningsByMonth: EarningsByMonth;
  EarningsByProductSummary: EarningsByProductSummary;
  EarningsItem: EarningsItem;
  ExchangeAmount: ExchangeAmount;
  ExchangeRate: ExchangeRate;
  ExchangeRateInput: ExchangeRateInput;
  ExclusivePostProduct: ExclusivePostProduct;
  FanOnboarding: FanOnboarding;
  Float: Scalars['Float']['output'];
  ImageAsset: ImageAsset;
  Int: Scalars['Int']['output'];
  IsEmailAvailableInput: IsEmailAvailableInput;
  IsUsernameAvailableInput: IsUsernameAvailableInput;
  IsUsernameValidInput: IsUsernameValidInput;
  IsValidUsernameResult: IsValidUsernameResult;
  LinkWalletInput: LinkWalletInput;
  LoginInput: LoginInput;
  LoginResult: LoginResult;
  Media: ResolversUnionTypes<ResolversParentTypes>['Media'];
  MessagePack: MessagePack;
  MessagePackProduct: MessagePackProduct;
  MessageSettings: MessageSettings;
  MessagingPreferencesInput: MessagingPreferencesInput;
  MobileVerificationResult: MobileVerificationResult;
  Mutation: {};
  NSFWSubscription: NsfwSubscription;
  Notification: Notification;
  OnboardingUnion: ResolversUnionTypes<ResolversParentTypes>['OnboardingUnion'];
  Order: Omit<Order, 'modifers' | 'products'> & { modifers?: Maybe<Array<ResolversParentTypes['OrderModiferUnion']>>, products: Array<ResolversParentTypes['ProductUnion']> };
  OrderFilter: OrderFilter;
  OrderModiferUnion: ResolversUnionTypes<ResolversParentTypes>['OrderModiferUnion'];
  OrderPostMediaInput: OrderPostMediaInput;
  Pageable: ResolversUnionTypes<ResolversParentTypes>['Pageable'];
  PaginatedResult: Omit<PaginatedResult, 'items'> & { items?: Maybe<Array<ResolversParentTypes['Pageable']>> };
  PaginationOptions: PaginationOptions;
  Plan: Plan;
  PlanOption: PlanOption;
  PlanOptionInput: PlanOptionInput;
  PlatformFee: PlatformFee;
  Post: Post;
  PostAsset: Omit<PostAsset, 'media'> & { media: ResolversParentTypes['Media'] };
  ProductInput: ProductInput;
  ProductUnion: ResolversUnionTypes<ResolversParentTypes>['ProductUnion'];
  Profile: Profile;
  PublishPostInput: PublishPostInput;
  Query: {};
  RecordPaymentInput: RecordPaymentInput;
  RecoverAccountInput: RecoverAccountInput;
  Referral: Referral;
  ResizedAsset: ResizedAsset;
  Sales: Sales;
  SeasonReferrals: SeasonReferrals;
  SendMessageInput: SendMessageInput;
  SendMobileVerificationInput: SendMobileVerificationInput;
  SetEmailInput: SetEmailInput;
  SetPasswordInput: SetPasswordInput;
  StartApplicationInput: StartApplicationInput;
  String: Scalars['String']['output'];
  SubscriptionProduct: SubscriptionProduct;
  Tag: Tag;
  TagFilter: TagFilter;
  TagInput: TagInput;
  TipProduct: TipProduct;
  ToggleLikePostInput: ToggleLikePostInput;
  UpdateEmailInput: UpdateEmailInput;
  UpdateMobileInput: UpdateMobileInput;
  UpdateOrderInput: UpdateOrderInput;
  UpdatePlanInput: UpdatePlanInput;
  UpdatePostInput: UpdatePostInput;
  Upload: Scalars['Upload']['output'];
  VerifyMobileInput: VerifyMobileInput;
  VideoAsset: VideoAsset;
  Wallet: Wallet;
  WithdrawalProduct: WithdrawalProduct;
}>;

export type AccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['Account'] = ResolversParentTypes['Account']> = ResolversObject<{
  accountStatus?: Resolver<ResolversTypes['UserStatus'], ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['AccountType'], ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['ImageAsset']>, ParentType, ContextType, RequireFields<AccountAvatarArgs, 'height' | 'width'>>;
  banner?: Resolver<Maybe<ResolversTypes['ImageAsset']>, ParentType, ContextType, RequireFields<AccountBannerArgs, 'height' | 'width'>>;
  bio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageCredits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  metadata?: Resolver<ResolversTypes['AccountMetadata'], ParentType, ContextType>;
  mobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pronouns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referralCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referrals?: Resolver<Maybe<ResolversTypes['PaginatedResult']>, ParentType, ContextType, RequireFields<AccountReferralsArgs, 'options'>>;
  salesCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['Tag']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  wallets?: Resolver<Array<ResolversTypes['Wallet']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountMetadata'] = ResolversParentTypes['AccountMetadata']> = ResolversObject<{
  onboarding?: Resolver<ResolversTypes['OnboardingUnion'], ParentType, ContextType>;
  subscribedProfiles?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApprovalResolvers<ContextType = any, ParentType extends ResolversParentTypes['Approval'] = ResolversParentTypes['Approval']> = ResolversObject<{
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  app?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  applicationUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  approvalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  approvalStatus?: Resolver<ResolversTypes['ApprovalStatus'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Comment'] = ResolversParentTypes['Comment']> = ResolversObject<{
  author?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  commentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  post?: Resolver<ResolversTypes['Post'], ParentType, ContextType>;
  postId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateAccountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateAccountResult'] = ResolversParentTypes['CreateAccountResult']> = ResolversObject<{
  accountStatus?: Resolver<ResolversTypes['UserStatus'], ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreatorOnboardingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatorOnboarding'] = ResolversParentTypes['CreatorOnboarding']> = ResolversObject<{
  approvals?: Resolver<Array<ResolversTypes['Approval']>, ParentType, ContextType>;
  createdSubscriptionPlan?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  firstWithdrawal?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasLinkedWallet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  setupMessaging?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updateBio?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updatedBio?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uploadedAvatar?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uploadedFirstPost?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CryptoCurrencyResolvers<ContextType = any, ParentType extends ResolversParentTypes['CryptoCurrency'] = ResolversParentTypes['CryptoCurrency']> = ResolversObject<{
  contract?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['TokenSymbol'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CryptoPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CryptoPayment'] = ResolversParentTypes['CryptoPayment']> = ResolversObject<{
  completedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  paymentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recipient?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PaymentStatus'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['CryptoCurrency'], ParentType, ContextType>;
  transactionHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CurrencyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Currency'] = ResolversParentTypes['Currency']> = ResolversObject<{
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DonationProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['DonationProduct'] = ResolversParentTypes['DonationProduct']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EarningsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Earnings'] = ResolversParentTypes['Earnings']> = ResolversObject<{
  analyticsInterval?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  availableToWithdraw?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sales?: Resolver<ResolversTypes['Sales'], ParentType, ContextType>;
  withdrawals?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EarningsByMonthResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarningsByMonth'] = ResolversParentTypes['EarningsByMonth']> = ResolversObject<{
  items?: Resolver<Array<ResolversTypes['EarningsItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EarningsByProductSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarningsByProductSummary'] = ResolversParentTypes['EarningsByProductSummary']> = ResolversObject<{
  count?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EarningsItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarningsItem'] = ResolversParentTypes['EarningsItem']> = ResolversObject<{
  exclusivePosts?: Resolver<Maybe<ResolversTypes['EarningsByProductSummary']>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  messages?: Resolver<Maybe<ResolversTypes['EarningsByProductSummary']>, ParentType, ContextType>;
  subscriptions?: Resolver<Maybe<ResolversTypes['EarningsByProductSummary']>, ParentType, ContextType>;
  tips?: Resolver<Maybe<ResolversTypes['EarningsByProductSummary']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ExchangeAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExchangeAmount'] = ResolversParentTypes['ExchangeAmount']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ExchangeRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExchangeRate'] = ResolversParentTypes['ExchangeRate']> = ResolversObject<{
  chainId?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  from?: Resolver<ResolversTypes['ExchangeAmount'], ParentType, ContextType>;
  spotPrice?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['ExchangeAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ExclusivePostProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExclusivePostProduct'] = ResolversParentTypes['ExclusivePostProduct']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  post?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FanOnboardingResolvers<ContextType = any, ParentType extends ResolversParentTypes['FanOnboarding'] = ResolversParentTypes['FanOnboarding']> = ResolversObject<{
  firstExclusivePost?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  firstFollow?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  firstLike?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  firstSubscription?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  firstTip?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasLinkedWallet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updateBio?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updatedBio?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uploadedAvatar?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ImageAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImageAsset'] = ResolversParentTypes['ImageAsset']> = ResolversObject<{
  aspectRatio?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fallbackUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  formats?: Resolver<Maybe<Array<ResolversTypes['ResizedAsset']>>, ParentType, ContextType>;
  originalHeight?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  originalWidth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IsValidUsernameResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['IsValidUsernameResult'] = ResolversParentTypes['IsValidUsernameResult']> = ResolversObject<{
  invalidCharacters?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  isValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LoginResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginResult'] = ResolversParentTypes['LoginResult']> = ResolversObject<{
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaResolvers<ContextType = any, ParentType extends ResolversParentTypes['Media'] = ResolversParentTypes['Media']> = ResolversObject<{
  __resolveType: TypeResolveFn<'ImageAsset' | 'VideoAsset', ParentType, ContextType>;
}>;

export type MessagePackResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagePack'] = ResolversParentTypes['MessagePack']> = ResolversObject<{
  credits?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messagePackId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MessagePackProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagePackProduct'] = ResolversParentTypes['MessagePackProduct']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  pack?: Resolver<Maybe<ResolversTypes['MessagePack']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MessageSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageSettings'] = ResolversParentTypes['MessageSettings']> = ResolversObject<{
  audience?: Resolver<Maybe<ResolversTypes['Audience']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rateId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MobileVerificationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MobileVerificationResult'] = ResolversParentTypes['MobileVerificationResult']> = ResolversObject<{
  expiresAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verificationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = ResolversObject<{
  addComment?: Resolver<ResolversTypes['Comment'], ParentType, ContextType, RequireFields<MutationAddCommentArgs, 'input'>>;
  archivePlan?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationArchivePlanArgs, 'planId'>>;
  authenticateFromEOA?: Resolver<ResolversTypes['CreateAccountResult'], ParentType, ContextType, RequireFields<MutationAuthenticateFromEoaArgs, 'input'>>;
  authenticateWithPrivy?: Resolver<ResolversTypes['CreateAccountResult'], ParentType, ContextType, RequireFields<MutationAuthenticateWithPrivyArgs, 'input'>>;
  changeEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  changePassword?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  changeUsername?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationChangeUsernameArgs, 'input'>>;
  claimReferralReward?: Resolver<ResolversTypes['Referral'], ParentType, ContextType, RequireFields<MutationClaimReferralRewardArgs, 'input'>>;
  clearNotifications?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  confirmEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationConfirmEmailArgs, 'input'>>;
  confirmPayment?: Resolver<ResolversTypes['CryptoPayment'], ParentType, ContextType, RequireFields<MutationConfirmPaymentArgs, 'input'>>;
  confirmWithdrawal?: Resolver<ResolversTypes['Order'], ParentType, ContextType, RequireFields<MutationConfirmWithdrawalArgs, 'input'>>;
  createAccount?: Resolver<ResolversTypes['CreateAccountResult'], ParentType, ContextType, RequireFields<MutationCreateAccountArgs, 'input'>>;
  createPlan?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationCreatePlanArgs, 'input'>>;
  createPost?: Resolver<ResolversTypes['Post'], ParentType, ContextType, RequireFields<MutationCreatePostArgs, 'input'>>;
  createReport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCreateReportArgs, 'input'>>;
  createSale?: Resolver<ResolversTypes['Order'], ParentType, ContextType, RequireFields<MutationCreateSaleArgs, 'input'>>;
  createSubscriptionSetting?: Resolver<ResolversTypes['PlanOption'], ParentType, ContextType, RequireFields<MutationCreateSubscriptionSettingArgs, 'input'>>;
  createTag?: Resolver<ResolversTypes['Tag'], ParentType, ContextType, RequireFields<MutationCreateTagArgs, 'input'>>;
  createThread?: Resolver<ResolversTypes['Post'], ParentType, ContextType, RequireFields<MutationCreateThreadArgs, 'input'>>;
  createWithdrawal?: Resolver<ResolversTypes['Order'], ParentType, ContextType, RequireFields<MutationCreateWithdrawalArgs, 'input'>>;
  deleteAccount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deleteNotification?: Resolver<ResolversTypes['Notification'], ParentType, ContextType, RequireFields<MutationDeleteNotificationArgs, 'notificationId'>>;
  deletePost?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeletePostArgs, 'postId'>>;
  deletePostMedia?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeletePostMediaArgs, 'ordinal' | 'postId'>>;
  discardPost?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDiscardPostArgs, 'postId'>>;
  followProfile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType, RequireFields<MutationFollowProfileArgs, 'profileId'>>;
  linkWallet?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationLinkWalletArgs, 'input'>>;
  login?: Resolver<ResolversTypes['LoginResult'], ParentType, ContextType, RequireFields<MutationLoginArgs, 'input'>>;
  messagingPreferences?: Resolver<ResolversTypes['Profile'], ParentType, ContextType, RequireFields<MutationMessagingPreferencesArgs, 'input'>>;
  orderPostMedia?: Resolver<ResolversTypes['Post'], ParentType, ContextType, RequireFields<MutationOrderPostMediaArgs, 'input'>>;
  publishPost?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationPublishPostArgs, 'input'>>;
  recordPayment?: Resolver<ResolversTypes['CryptoPayment'], ParentType, ContextType, RequireFields<MutationRecordPaymentArgs, 'input'>>;
  recoverAccount?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationRecoverAccountArgs, 'input'>>;
  requestApproval?: Resolver<ResolversTypes['Approval'], ParentType, ContextType>;
  resolveApproval?: Resolver<ResolversTypes['Approval'], ParentType, ContextType, RequireFields<MutationResolveApprovalArgs, 'uid'>>;
  sendMessage?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<MutationSendMessageArgs, 'input'>>;
  sendMobileVerification?: Resolver<ResolversTypes['MobileVerificationResult'], ParentType, ContextType, RequireFields<MutationSendMobileVerificationArgs, 'input'>>;
  sendUpdateMobileVerification?: Resolver<ResolversTypes['MobileVerificationResult'], ParentType, ContextType, RequireFields<MutationSendUpdateMobileVerificationArgs, 'input'>>;
  setEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationSetEmailArgs, 'input'>>;
  setPassword?: Resolver<ResolversTypes['LoginResult'], ParentType, ContextType, RequireFields<MutationSetPasswordArgs, 'input'>>;
  startApplication?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationStartApplicationArgs, 'input'>>;
  toggleLikePost?: Resolver<ResolversTypes['Post'], ParentType, ContextType, RequireFields<MutationToggleLikePostArgs, 'input'>>;
  toggleNotificationRead?: Resolver<ResolversTypes['Notification'], ParentType, ContextType, RequireFields<MutationToggleNotificationReadArgs, 'notificationId'>>;
  unfollowProfile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType, RequireFields<MutationUnfollowProfileArgs, 'profileId'>>;
  updateAvatar?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationUpdateAvatarArgs, 'image'>>;
  updateBanner?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationUpdateBannerArgs, 'image'>>;
  updateBio?: Resolver<ResolversTypes['Profile'], ParentType, ContextType, RequireFields<MutationUpdateBioArgs, 'bio'>>;
  updateDisplayName?: Resolver<ResolversTypes['Profile'], ParentType, ContextType, RequireFields<MutationUpdateDisplayNameArgs, 'displayName'>>;
  updateEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationUpdateEmailArgs, 'input'>>;
  updateMobile?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationUpdateMobileArgs, 'input'>>;
  updateOrder?: Resolver<ResolversTypes['Order'], ParentType, ContextType, RequireFields<MutationUpdateOrderArgs, 'input'>>;
  updatePlan?: Resolver<ResolversTypes['Plan'], ParentType, ContextType, RequireFields<MutationUpdatePlanArgs, 'input'>>;
  updatePost?: Resolver<ResolversTypes['Post'], ParentType, ContextType, RequireFields<MutationUpdatePostArgs, 'input'>>;
  updatePostTags?: Resolver<ResolversTypes['Post'], ParentType, ContextType, RequireFields<MutationUpdatePostTagsArgs, 'postId' | 'tagIds'>>;
  updatePronouns?: Resolver<ResolversTypes['Profile'], ParentType, ContextType, RequireFields<MutationUpdatePronounsArgs, 'pronouns'>>;
  updateTags?: Resolver<ResolversTypes['Profile'], ParentType, ContextType, RequireFields<MutationUpdateTagsArgs, 'tagIds'>>;
  verifyMobile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationVerifyMobileArgs, 'input'>>;
}>;

export type NsfwSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NSFWSubscription'] = ResolversParentTypes['NSFWSubscription']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Order'], ParentType, ContextType>;
  plan?: Resolver<ResolversTypes['Plan'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SubscriptionStatus'], ParentType, ContextType>;
  subscriber?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Notification'] = ResolversParentTypes['Notification']> = ResolversObject<{
  actor?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  notificationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notificationType?: Resolver<ResolversTypes['NotificationType'], ParentType, ContextType>;
  paymentAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentProductType?: Resolver<Maybe<ResolversTypes['ProductType']>, ParentType, ContextType>;
  post?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType>;
  postId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  withdrawalAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  withdrawalCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  withdrawalTxn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OnboardingUnionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingUnion'] = ResolversParentTypes['OnboardingUnion']> = ResolversObject<{
  __resolveType: TypeResolveFn<'CreatorOnboarding' | 'FanOnboarding', ParentType, ContextType>;
}>;

export type OrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['Order'] = ResolversParentTypes['Order']> = ResolversObject<{
  chainId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customer?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  modifers?: Resolver<Maybe<Array<ResolversTypes['OrderModiferUnion']>>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payments?: Resolver<Array<ResolversTypes['CryptoPayment']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  products?: Resolver<Array<ResolversTypes['ProductUnion']>, ParentType, ContextType>;
  recipient?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OrderStatus'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['CryptoCurrency'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OrderType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderModiferUnionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderModiferUnion'] = ResolversParentTypes['OrderModiferUnion']> = ResolversObject<{
  __resolveType: TypeResolveFn<'PlatformFee', ParentType, ContextType>;
}>;

export type PageableResolvers<ContextType = any, ParentType extends ResolversParentTypes['Pageable'] = ResolversParentTypes['Pageable']> = ResolversObject<{
  __resolveType: TypeResolveFn<'Comment' | 'NSFWSubscription' | 'Notification' | 'Order' | 'Post' | 'Profile' | 'Referral' | 'Tag', ParentType, ContextType>;
}>;

export type PaginatedResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedResult'] = ResolversParentTypes['PaginatedResult']> = ResolversObject<{
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Pageable']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['Plan'] = ResolversParentTypes['Plan']> = ResolversObject<{
  colour?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  interval?: Resolver<ResolversTypes['Interval'], ParentType, ContextType>;
  planId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlanOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlanOption'] = ResolversParentTypes['PlanOption']> = ResolversObject<{
  duration?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  interval?: Resolver<ResolversTypes['Interval'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlatformFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformFee'] = ResolversParentTypes['PlatformFee']> = ResolversObject<{
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PostResolvers<ContextType = any, ParentType extends ResolversParentTypes['Post'] = ResolversParentTypes['Post']> = ResolversObject<{
  asset?: Resolver<Maybe<Array<ResolversTypes['PostAsset']>>, ParentType, ContextType>;
  commentCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  comments?: Resolver<ResolversTypes['PaginatedResult'], ParentType, ContextType, RequireFields<PostCommentsArgs, 'options'>>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isLiked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isOwner?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSubscribed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  likeCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  permalink?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profile?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PostStatus'], ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['Tag']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PostType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PostAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostAsset'] = ResolversParentTypes['PostAsset']> = ResolversObject<{
  media?: Resolver<ResolversTypes['Media'], ParentType, ContextType>;
  ordinal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductUnionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductUnion'] = ResolversParentTypes['ProductUnion']> = ResolversObject<{
  __resolveType: TypeResolveFn<'DonationProduct' | 'ExclusivePostProduct' | 'MessagePackProduct' | 'SubscriptionProduct' | 'TipProduct' | 'WithdrawalProduct', ParentType, ContextType>;
}>;

export type ProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['Profile'] = ResolversParentTypes['Profile']> = ResolversObject<{
  accountType?: Resolver<ResolversTypes['AccountType'], ParentType, ContextType>;
  activeSubscriberCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['ImageAsset']>, ParentType, ContextType, RequireFields<ProfileAvatarArgs, 'height' | 'width'>>;
  banner?: Resolver<Maybe<ResolversTypes['ImageAsset']>, ParentType, ContextType, RequireFields<ProfileBannerArgs, 'height' | 'width'>>;
  bio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  followers?: Resolver<Maybe<ResolversTypes['PaginatedResult']>, ParentType, ContextType, RequireFields<ProfileFollowersArgs, 'options'>>;
  followersCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  following?: Resolver<Maybe<ResolversTypes['PaginatedResult']>, ParentType, ContextType, RequireFields<ProfileFollowingArgs, 'options'>>;
  followingCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  isFollowing?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  messaging?: Resolver<Maybe<ResolversTypes['MessageSettings']>, ParentType, ContextType>;
  posts?: Resolver<ResolversTypes['PaginatedResult'], ParentType, ContextType, RequireFields<ProfilePostsArgs, 'filter' | 'options'>>;
  postsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pronouns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referralUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['Tag']>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  creatorSubscriptions?: Resolver<ResolversTypes['PaginatedResult'], ParentType, ContextType, RequireFields<QueryCreatorSubscriptionsArgs, 'filter' | 'options'>>;
  earnings?: Resolver<ResolversTypes['Earnings'], ParentType, ContextType>;
  exchangeRate?: Resolver<ResolversTypes['ExchangeRate'], ParentType, ContextType, RequireFields<QueryExchangeRateArgs, 'input'>>;
  feed?: Resolver<ResolversTypes['PaginatedResult'], ParentType, ContextType, RequireFields<QueryFeedArgs, 'options' | 'type'>>;
  isEmailAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsEmailAvailableArgs, 'input'>>;
  isUsernameAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsUsernameAvailableArgs, 'input'>>;
  isUsernameValid?: Resolver<ResolversTypes['IsValidUsernameResult'], ParentType, ContextType, RequireFields<QueryIsUsernameValidArgs, 'input'>>;
  isVerificationValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsVerificationValidArgs, 'token'>>;
  listUnconfiguredPlans?: Resolver<Array<ResolversTypes['PlanOption']>, ParentType, ContextType>;
  me?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  messagePacks?: Resolver<Array<ResolversTypes['MessagePack']>, ParentType, ContextType>;
  mySubscriptions?: Resolver<ResolversTypes['PaginatedResult'], ParentType, ContextType, RequireFields<QueryMySubscriptionsArgs, 'filter' | 'options'>>;
  nonce?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notifications?: Resolver<ResolversTypes['PaginatedResult'], ParentType, ContextType, RequireFields<QueryNotificationsArgs, 'options'>>;
  orders?: Resolver<ResolversTypes['PaginatedResult'], ParentType, ContextType, RequireFields<QueryOrdersArgs, 'options'>>;
  sales?: Resolver<ResolversTypes['PaginatedResult'], ParentType, ContextType, RequireFields<QuerySalesArgs, 'options'>>;
  scheduledPosts?: Resolver<ResolversTypes['PaginatedResult'], ParentType, ContextType, RequireFields<QueryScheduledPostsArgs, 'options'>>;
  search?: Resolver<ResolversTypes['PaginatedResult'], ParentType, ContextType, RequireFields<QuerySearchArgs, 'options' | 'query'>>;
  seasonOneReferrals?: Resolver<ResolversTypes['SeasonReferrals'], ParentType, ContextType>;
  subscribers?: Resolver<ResolversTypes['PaginatedResult'], ParentType, ContextType, RequireFields<QuerySubscribersArgs, 'filter' | 'options'>>;
  suggestions?: Resolver<Array<ResolversTypes['Profile']>, ParentType, ContextType>;
  tags?: Resolver<ResolversTypes['PaginatedResult'], ParentType, ContextType, RequireFields<QueryTagsArgs, 'input' | 'options'>>;
  unreadNotificationsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  viewCreatorPlans?: Resolver<Array<ResolversTypes['Plan']>, ParentType, ContextType, RequireFields<QueryViewCreatorPlansArgs, 'creatorId'>>;
  viewOrder?: Resolver<ResolversTypes['Order'], ParentType, ContextType, RequireFields<QueryViewOrderArgs, 'orderId'>>;
  viewPost?: Resolver<ResolversTypes['Post'], ParentType, ContextType, RequireFields<QueryViewPostArgs, 'postId'>>;
  viewProfile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType, Partial<QueryViewProfileArgs>>;
}>;

export type ReferralResolvers<ContextType = any, ParentType extends ResolversParentTypes['Referral'] = ResolversParentTypes['Referral']> = ResolversObject<{
  completedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  referralId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rewardAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rewardAmountUSD?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rewards?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ResizedAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResizedAsset'] = ResolversParentTypes['ResizedAsset']> = ResolversObject<{
  fallbackUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  format?: Resolver<ResolversTypes['ResizedAssetFormat'], ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SalesResolvers<ContextType = any, ParentType extends ResolversParentTypes['Sales'] = ResolversParentTypes['Sales']> = ResolversObject<{
  byMonth?: Resolver<ResolversTypes['EarningsByMonth'], ParentType, ContextType>;
  exclusivePosts?: Resolver<ResolversTypes['EarningsByProductSummary'], ParentType, ContextType>;
  messages?: Resolver<ResolversTypes['EarningsByProductSummary'], ParentType, ContextType>;
  subscriptions?: Resolver<ResolversTypes['EarningsByProductSummary'], ParentType, ContextType>;
  tips?: Resolver<ResolversTypes['EarningsByProductSummary'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SeasonReferralsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeasonReferrals'] = ResolversParentTypes['SeasonReferrals']> = ResolversObject<{
  rewardsRemaining?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rewardsTotal?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionProduct'] = ResolversParentTypes['SubscriptionProduct']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  plan?: Resolver<ResolversTypes['Plan'], ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['NSFWSubscription']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TagResolvers<ContextType = any, ParentType extends ResolversParentTypes['Tag'] = ResolversParentTypes['Tag']> = ResolversObject<{
  emoji?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes['TagKey'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tagId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TipProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['TipProduct'] = ResolversParentTypes['TipProduct']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  post?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type VideoAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoAsset'] = ResolversParentTypes['VideoAsset']> = ResolversObject<{
  aspectRatio?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fallbackUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  formats?: Resolver<Maybe<Array<ResolversTypes['ResizedAsset']>>, ParentType, ContextType>;
  originalHeight?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  originalWidth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WalletResolvers<ContextType = any, ParentType extends ResolversParentTypes['Wallet'] = ResolversParentTypes['Wallet']> = ResolversObject<{
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isLinked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WithdrawalProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithdrawalProduct'] = ResolversParentTypes['WithdrawalProduct']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = any> = ResolversObject<{
  Account?: AccountResolvers<ContextType>;
  AccountMetadata?: AccountMetadataResolvers<ContextType>;
  Approval?: ApprovalResolvers<ContextType>;
  Comment?: CommentResolvers<ContextType>;
  CreateAccountResult?: CreateAccountResultResolvers<ContextType>;
  CreatorOnboarding?: CreatorOnboardingResolvers<ContextType>;
  CryptoCurrency?: CryptoCurrencyResolvers<ContextType>;
  CryptoPayment?: CryptoPaymentResolvers<ContextType>;
  Currency?: CurrencyResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  DonationProduct?: DonationProductResolvers<ContextType>;
  Earnings?: EarningsResolvers<ContextType>;
  EarningsByMonth?: EarningsByMonthResolvers<ContextType>;
  EarningsByProductSummary?: EarningsByProductSummaryResolvers<ContextType>;
  EarningsItem?: EarningsItemResolvers<ContextType>;
  ExchangeAmount?: ExchangeAmountResolvers<ContextType>;
  ExchangeRate?: ExchangeRateResolvers<ContextType>;
  ExclusivePostProduct?: ExclusivePostProductResolvers<ContextType>;
  FanOnboarding?: FanOnboardingResolvers<ContextType>;
  ImageAsset?: ImageAssetResolvers<ContextType>;
  IsValidUsernameResult?: IsValidUsernameResultResolvers<ContextType>;
  LoginResult?: LoginResultResolvers<ContextType>;
  Media?: MediaResolvers<ContextType>;
  MessagePack?: MessagePackResolvers<ContextType>;
  MessagePackProduct?: MessagePackProductResolvers<ContextType>;
  MessageSettings?: MessageSettingsResolvers<ContextType>;
  MobileVerificationResult?: MobileVerificationResultResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NSFWSubscription?: NsfwSubscriptionResolvers<ContextType>;
  Notification?: NotificationResolvers<ContextType>;
  OnboardingUnion?: OnboardingUnionResolvers<ContextType>;
  Order?: OrderResolvers<ContextType>;
  OrderModiferUnion?: OrderModiferUnionResolvers<ContextType>;
  Pageable?: PageableResolvers<ContextType>;
  PaginatedResult?: PaginatedResultResolvers<ContextType>;
  Plan?: PlanResolvers<ContextType>;
  PlanOption?: PlanOptionResolvers<ContextType>;
  PlatformFee?: PlatformFeeResolvers<ContextType>;
  Post?: PostResolvers<ContextType>;
  PostAsset?: PostAssetResolvers<ContextType>;
  ProductUnion?: ProductUnionResolvers<ContextType>;
  Profile?: ProfileResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Referral?: ReferralResolvers<ContextType>;
  ResizedAsset?: ResizedAssetResolvers<ContextType>;
  Sales?: SalesResolvers<ContextType>;
  SeasonReferrals?: SeasonReferralsResolvers<ContextType>;
  SubscriptionProduct?: SubscriptionProductResolvers<ContextType>;
  Tag?: TagResolvers<ContextType>;
  TipProduct?: TipProductResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  VideoAsset?: VideoAssetResolvers<ContextType>;
  Wallet?: WalletResolvers<ContextType>;
  WithdrawalProduct?: WithdrawalProductResolvers<ContextType>;
}>;


export type CommentPartsFragment = { __typename: 'Comment', commentId: string, createdBy: string, createdAt: string, text: string, postId: string, author: { __typename?: 'Profile', displayName: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null } };

export type OrderPartsFragment = { __typename: 'Order', orderId: string, price: string, chainId: number, recipient: string, status: OrderStatus, createdAt: any, currencyCode: string, total: string, token: { __typename?: 'CryptoCurrency', symbol: TokenSymbol }, modifers?: Array<{ __typename: 'PlatformFee', unit: string, key: string, label: string, value: number }> | null };

export type PaymentsPartsFragment = { __typename?: 'Order', payments: Array<{ __typename: 'CryptoPayment', paymentId: string, status: PaymentStatus, transactionHash?: string | null, signer: string, recipient: string, createdAt: any, completedAt?: any | null, token: { __typename?: 'CryptoCurrency', symbol: TokenSymbol, contract: string } }> };

export type PlanPartsFragment = { __typename?: 'Plan', planId: string, description: string, interval: Interval, duration: number, price: number, colour: string };

export type PostPartsFragment = { __typename?: 'Post', type: PostType, postId: string, isVisible: boolean, description?: string | null, likeCount: number, profileId: string, isLiked: boolean, publishedAt?: string | null, isSubscribed: boolean, isOwner: boolean, price?: number | null, commentCount: number, status: PostStatus, profile?: { __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null } | null, asset?: Array<{ __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, originalWidth: number, originalHeight: number, aspectRatio: number } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number } }> | null };

export type PostWithAssetFormatsFragment = { __typename: 'Post', type: PostType, postId: string, isVisible: boolean, description?: string | null, likeCount: number, profileId: string, isLiked: boolean, publishedAt?: string | null, isSubscribed: boolean, isOwner: boolean, price?: number | null, commentCount: number, status: PostStatus, profile?: { __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null } | null, asset?: Array<{ __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, fallbackUrl: string, originalWidth: number, originalHeight: number, aspectRatio: number, formats?: Array<{ __typename?: 'ResizedAsset', format: ResizedAssetFormat, url: string, fallbackUrl: string, width?: number | null, height?: number | null }> | null } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number, formats?: Array<{ __typename?: 'ResizedAsset', format: ResizedAssetFormat, url: string, fallbackUrl: string, width?: number | null, height?: number | null }> | null } }> | null };

export type PostAssetPartsFragment = { __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, originalWidth: number, originalHeight: number, aspectRatio: number } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number } };

export type PostAssetFormatsPartsFragment = { __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, fallbackUrl: string, originalWidth: number, originalHeight: number, aspectRatio: number, formats?: Array<{ __typename?: 'ResizedAsset', format: ResizedAssetFormat, url: string, fallbackUrl: string, width?: number | null, height?: number | null }> | null } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number, formats?: Array<{ __typename?: 'ResizedAsset', format: ResizedAssetFormat, url: string, fallbackUrl: string, width?: number | null, height?: number | null }> | null } };

type ProductParts_DonationProduct_Fragment = { __typename: 'DonationProduct', type: ProductType, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null };

type ProductParts_ExclusivePostProduct_Fragment = { __typename: 'ExclusivePostProduct', type: ProductType, post?: { __typename?: 'Post', postId: string, description?: string | null, asset?: Array<{ __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, originalWidth: number, originalHeight: number, aspectRatio: number } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number } }> | null } | null, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null };

type ProductParts_MessagePackProduct_Fragment = { __typename: 'MessagePackProduct', type: ProductType, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null, pack?: { __typename?: 'MessagePack', messagePackId: string, credits: number, title: string, description?: string | null } | null };

type ProductParts_SubscriptionProduct_Fragment = { __typename: 'SubscriptionProduct', type: ProductType, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null, plan: { __typename?: 'Plan', interval: Interval, duration: number }, subscription?: { __typename?: 'NSFWSubscription', createdAt: string, expiresAt: string } | null };

type ProductParts_TipProduct_Fragment = { __typename: 'TipProduct', type: ProductType, post?: { __typename?: 'Post', postId: string, description?: string | null, asset?: Array<{ __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, originalWidth: number, originalHeight: number, aspectRatio: number } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number } }> | null } | null, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null };

type ProductParts_WithdrawalProduct_Fragment = { __typename: 'WithdrawalProduct', type: ProductType, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null };

export type ProductPartsFragment = ProductParts_DonationProduct_Fragment | ProductParts_ExclusivePostProduct_Fragment | ProductParts_MessagePackProduct_Fragment | ProductParts_SubscriptionProduct_Fragment | ProductParts_TipProduct_Fragment | ProductParts_WithdrawalProduct_Fragment;

export type ProfilePartsFragment = { __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null };

export type ProfileStatFieldsFragment = { __typename?: 'Profile', followersCount: number, activeSubscriberCount: number, followingCount: number, postsCount: number };

export type AddCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type AddCommentMutation = { __typename?: 'Mutation', addComment: { __typename: 'Comment', commentId: string, createdBy: string, createdAt: string, text: string, postId: string, author: { __typename?: 'Profile', displayName: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null } } };

export type AuthenticateFromEoaMutationVariables = Exact<{
  input: CreateAccountFromEoaInput;
}>;


export type AuthenticateFromEoaMutation = { __typename?: 'Mutation', authenticateFromEOA: { __typename?: 'CreateAccountResult', token?: string | null } };

export type AuthenticateWithPrivyMutationVariables = Exact<{
  input: AuthenticateWithPrivyInput;
}>;


export type AuthenticateWithPrivyMutation = { __typename?: 'Mutation', authenticateWithPrivy: { __typename?: 'CreateAccountResult', token?: string | null } };

export type ClaimReferralRewardMutationVariables = Exact<{
  input: ClaimReferralRewardInput;
}>;


export type ClaimReferralRewardMutation = { __typename?: 'Mutation', claimReferralReward: { __typename?: 'Referral', referralId: string, type: string, status: string } };

export type CreateAccountMutationVariables = Exact<{
  input: CreateAccountInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount: { __typename?: 'CreateAccountResult', token?: string | null } };

export type CreatePostMutationVariables = Exact<{
  input: CreatePostInput;
}>;


export type CreatePostMutation = { __typename?: 'Mutation', createPost: { __typename?: 'Post', postId: string, createdAt: string, tags?: Array<{ __typename?: 'Tag', key: TagKey, slug: string, tagId: string, value: string }> | null } };

export type CreateTagMutationVariables = Exact<{
  input: TagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'Tag', key: TagKey, slug: string, value: string, tagId: string } };

export type CreateWithdrawalMutationVariables = Exact<{
  input: CreateWithdrawalInput;
}>;


export type CreateWithdrawalMutation = { __typename?: 'Mutation', createWithdrawal: { __typename?: 'Order', orderId: string, chainId: number, status: OrderStatus, signer: string, recipient: string, currencyCode: string, total: string, createdAt: any, token: { __typename?: 'CryptoCurrency', symbol: TokenSymbol, contract: string } } };

export type CreatePlanMutationVariables = Exact<{
  input: CreatePlanInput;
}>;


export type CreatePlanMutation = { __typename?: 'Mutation', createPlan: { __typename?: 'Plan', planId: string, title: string, description: string, interval: Interval, duration: number, price: number, currency: { __typename?: 'Currency', currencyCode: string } } };

export type UpdateMutationVariables = Exact<{
  input: UpdatePlanInput;
}>;


export type UpdateMutation = { __typename?: 'Mutation', updatePlan: { __typename?: 'Plan', planId: string, title: string, description: string, interval: Interval, duration: number, price: number, currency: { __typename?: 'Currency', currencyCode: string } } };

export type ArchivePlanMutationVariables = Exact<{
  planId: Scalars['String']['input'];
}>;


export type ArchivePlanMutation = { __typename?: 'Mutation', archivePlan: boolean };

export type DeletePostMutationVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type DeletePostMutation = { __typename?: 'Mutation', deletePost: boolean };

export type DeletePostMediaMutationVariables = Exact<{
  ordinal: Scalars['Int']['input'];
  postId: Scalars['String']['input'];
}>;


export type DeletePostMediaMutation = { __typename?: 'Mutation', deletePostMedia: boolean };

export type DiscardPostMutationVariables = Exact<{
  postId: Scalars['String']['input'];
}>;


export type DiscardPostMutation = { __typename?: 'Mutation', discardPost: boolean };

export type FollowProfileMutationVariables = Exact<{
  profileId: Scalars['String']['input'];
}>;


export type FollowProfileMutation = { __typename?: 'Mutation', followProfile: { __typename?: 'Profile', isFollowing: boolean } };

export type LinkWalletMutationMutationVariables = Exact<{
  input: LinkWalletInput;
}>;


export type LinkWalletMutationMutation = { __typename?: 'Mutation', linkWallet: boolean };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResult', token: string } };

export type ToggleNotificationReadMutationVariables = Exact<{
  notificationId: Scalars['String']['input'];
}>;


export type ToggleNotificationReadMutation = { __typename?: 'Mutation', toggleNotificationRead: { __typename?: 'Notification', title: string, userId: string, notificationType: NotificationType, createdAt: string, postId?: string | null, isRead: boolean, paymentAmount?: string | null, paymentProductType?: ProductType | null, paymentCurrency?: string | null, withdrawalAmount?: string | null, withdrawalTxn?: string | null, withdrawalCurrency?: string | null } };

export type DeleteNotificationMutationVariables = Exact<{
  notificationId: Scalars['String']['input'];
}>;


export type DeleteNotificationMutation = { __typename?: 'Mutation', deleteNotification: { __typename?: 'Notification', title: string, userId: string, notificationType: NotificationType, createdAt: string, postId?: string | null, isRead: boolean, paymentAmount?: string | null, paymentProductType?: ProductType | null, paymentCurrency?: string | null, withdrawalAmount?: string | null, withdrawalTxn?: string | null, withdrawalCurrency?: string | null } };

export type ClearNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearNotificationsMutation = { __typename?: 'Mutation', clearNotifications: boolean };

export type OrderPostMediaMutationVariables = Exact<{
  input: OrderPostMediaInput;
}>;


export type OrderPostMediaMutation = { __typename?: 'Mutation', orderPostMedia: { __typename?: 'Post', postId: string, asset?: Array<{ __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, originalWidth: number, originalHeight: number, aspectRatio: number } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number } }> | null } };

export type CreateSaleMutationMutationVariables = Exact<{
  input: CreateSaleInput;
}>;


export type CreateSaleMutationMutation = { __typename?: 'Mutation', createSale: { __typename?: 'Order', orderId: string, chainId: number, status: OrderStatus, signer: string, recipient: string, currencyCode: string, total: string, createdAt: any, token: { __typename?: 'CryptoCurrency', symbol: TokenSymbol, contract: string }, customer?: { __typename?: 'Profile', accountType: AccountType, profileId: string } | null } };

export type UpdateOrderMutationMutationVariables = Exact<{
  input: UpdateOrderInput;
}>;


export type UpdateOrderMutationMutation = { __typename?: 'Mutation', updateOrder: { __typename?: 'Order', orderId: string, chainId: number, status: OrderStatus, signer: string, recipient: string, currencyCode: string, total: string, createdAt: any, token: { __typename?: 'CryptoCurrency', symbol: TokenSymbol, contract: string }, customer?: { __typename?: 'Profile', accountType: AccountType, profileId: string } | null } };

export type RecordPaymentMutationMutationVariables = Exact<{
  input: RecordPaymentInput;
}>;


export type RecordPaymentMutationMutation = { __typename?: 'Mutation', recordPayment: { __typename?: 'CryptoPayment', status: PaymentStatus, paymentId: string, signer: string, recipient: string, transactionHash?: string | null, token: { __typename?: 'CryptoCurrency', symbol: TokenSymbol, contract: string } } };

export type ConfirmPaymentMutationMutationVariables = Exact<{
  input: ConfirmPaymentInput;
}>;


export type ConfirmPaymentMutationMutation = { __typename?: 'Mutation', confirmPayment: { __typename?: 'CryptoPayment', status: PaymentStatus, paymentId: string, signer: string, recipient: string, transactionHash?: string | null, token: { __typename?: 'CryptoCurrency', symbol: TokenSymbol, contract: string } } };

export type ConfirmWithdrawalMutationMutationVariables = Exact<{
  input: ConfirmWithdrawalInput;
}>;


export type ConfirmWithdrawalMutationMutation = { __typename?: 'Mutation', confirmWithdrawal: { __typename?: 'Order', status: OrderStatus, signer: string, recipient: string, token: { __typename?: 'CryptoCurrency', symbol: TokenSymbol, contract: string }, payments: Array<{ __typename: 'CryptoPayment', paymentId: string, status: PaymentStatus, transactionHash?: string | null, signer: string, recipient: string, createdAt: any, completedAt?: any | null, token: { __typename?: 'CryptoCurrency', symbol: TokenSymbol, contract: string } }> } };

export type ChangePasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: string };

export type ChangeUsernameMutationVariables = Exact<{
  input: ChangeUsernameInput;
}>;


export type ChangeUsernameMutation = { __typename?: 'Mutation', changeUsername: { __typename?: 'Account', username: string } };

export type DeleteAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: string };

export type UpdateAvatarMutationVariables = Exact<{
  image: Scalars['Upload']['input'];
}>;


export type UpdateAvatarMutation = { __typename?: 'Mutation', updateAvatar: { __typename?: 'Account', avatar?: { __typename?: 'ImageAsset', url: string } | null } };

export type UpdateBioMutationVariables = Exact<{
  bio: Scalars['String']['input'];
}>;


export type UpdateBioMutation = { __typename?: 'Mutation', updateBio: { __typename?: 'Profile', bio?: string | null } };

export type UpdateDisplayNameMutationVariables = Exact<{
  displayName: Scalars['String']['input'];
}>;


export type UpdateDisplayNameMutation = { __typename?: 'Mutation', updateDisplayName: { __typename?: 'Profile', displayName: string } };

export type ChangeEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ChangeEmailMutation = { __typename?: 'Mutation', changeEmail: string };

export type UpdateEmailMutationVariables = Exact<{
  input: UpdateEmailInput;
}>;


export type UpdateEmailMutation = { __typename?: 'Mutation', updateEmail: string };

export type SetEmailMutationVariables = Exact<{
  input: SetEmailInput;
}>;


export type SetEmailMutation = { __typename?: 'Mutation', setEmail: string };

export type ConfirmEmailMutationVariables = Exact<{
  input: ConfirmEmailInput;
}>;


export type ConfirmEmailMutation = { __typename?: 'Mutation', confirmEmail: string };

export type MessagingPreferencesMutationVariables = Exact<{
  input: MessagingPreferencesInput;
}>;


export type MessagingPreferencesMutation = { __typename?: 'Mutation', messagingPreferences: { __typename?: 'Profile', messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null } };

export type SendMobileVerificationMutationVariables = Exact<{
  input: SendMobileVerificationInput;
}>;


export type SendMobileVerificationMutation = { __typename?: 'Mutation', sendMobileVerification: { __typename?: 'MobileVerificationResult', verificationId: string, expiresAt: string } };

export type SendUpdateMobileVerificationMutationVariables = Exact<{
  input: SendMobileVerificationInput;
}>;


export type SendUpdateMobileVerificationMutation = { __typename?: 'Mutation', sendUpdateMobileVerification: { __typename?: 'MobileVerificationResult', verificationId: string, expiresAt: string } };

export type VerifyMobileMutationVariables = Exact<{
  input: VerifyMobileInput;
}>;


export type VerifyMobileMutation = { __typename?: 'Mutation', verifyMobile: boolean };

export type UpdateMobileMutationVariables = Exact<{
  input: UpdateMobileInput;
}>;


export type UpdateMobileMutation = { __typename?: 'Mutation', updateMobile: { __typename?: 'Account', userId: string, mobile?: string | null } };

export type PublishPostMutationVariables = Exact<{
  input: PublishPostInput;
}>;


export type PublishPostMutation = { __typename?: 'Mutation', publishPost: boolean };

export type ExchangeRateQueryVariables = Exact<{
  input: ExchangeRateInput;
}>;


export type ExchangeRateQuery = { __typename?: 'Query', exchangeRate: { __typename?: 'ExchangeRate', chainId: number, spotPrice: string, from: { __typename?: 'ExchangeAmount', symbol: string, amount: string }, to: { __typename?: 'ExchangeAmount', symbol: string, amount: string } } };

export type RecoverAccountMutationVariables = Exact<{
  input: RecoverAccountInput;
}>;


export type RecoverAccountMutation = { __typename?: 'Mutation', recoverAccount: string };

export type CreateReportMutationVariables = Exact<{
  input: CreateReportInput;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport: boolean };

export type RequestApprovalMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestApprovalMutation = { __typename?: 'Mutation', requestApproval: { __typename?: 'Approval', approvalId: string, approvalStatus: ApprovalStatus, applicationUrl: string, createdAt: string, uid: string } };

export type ResolveApprovalMutationVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type ResolveApprovalMutation = { __typename?: 'Mutation', resolveApproval: { __typename?: 'Approval', approvalStatus: ApprovalStatus, createdAt: string, uid: string } };

export type SendMessageMutationVariables = Exact<{
  input: SendMessageInput;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage: number };

export type SetPasswordMutationVariables = Exact<{
  input: SetPasswordInput;
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setPassword: { __typename?: 'LoginResult', token: string } };

export type ToggleLikePostMutationVariables = Exact<{
  input: ToggleLikePostInput;
}>;


export type ToggleLikePostMutation = { __typename?: 'Mutation', toggleLikePost: { __typename?: 'Post', postId: string, isLiked: boolean, likeCount: number } };

export type UnfollowProfileMutationVariables = Exact<{
  profileId: Scalars['String']['input'];
}>;


export type UnfollowProfileMutation = { __typename?: 'Mutation', unfollowProfile: { __typename?: 'Profile', isFollowing: boolean } };

export type UpdatePostMutationVariables = Exact<{
  input: UpdatePostInput;
}>;


export type UpdatePostMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'Post', postId: string, status: PostStatus } };

export type UpdatePronounsMutationVariables = Exact<{
  pronouns: Scalars['String']['input'];
}>;


export type UpdatePronounsMutation = { __typename?: 'Mutation', updatePronouns: { __typename?: 'Profile', pronouns?: string | null } };

export type UpdateTagsMutationVariables = Exact<{
  tagIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateTagsMutation = { __typename?: 'Mutation', updateTags: { __typename?: 'Profile', tags: Array<{ __typename?: 'Tag', tagId: string }> } };

export type QueryEarningsQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryEarningsQuery = { __typename?: 'Query', earnings: { __typename?: 'Earnings', analyticsInterval: string, availableToWithdraw?: number | null, sales: { __typename?: 'Sales', unit: string, total: number, exclusivePosts: { __typename?: 'EarningsByProductSummary', total: number, count: number }, subscriptions: { __typename?: 'EarningsByProductSummary', total: number, count: number }, messages: { __typename?: 'EarningsByProductSummary', total: number, count: number }, tips: { __typename?: 'EarningsByProductSummary', total: number, count: number } } } };

export type QueryEarningsByMonthQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryEarningsByMonthQuery = { __typename?: 'Query', earnings: { __typename?: 'Earnings', analyticsInterval: string, availableToWithdraw?: number | null, sales: { __typename?: 'Sales', unit: string, total: number, exclusivePosts: { __typename?: 'EarningsByProductSummary', total: number, count: number }, subscriptions: { __typename?: 'EarningsByProductSummary', total: number, count: number }, tips: { __typename?: 'EarningsByProductSummary', total: number, count: number }, messages: { __typename?: 'EarningsByProductSummary', total: number, count: number }, byMonth: { __typename?: 'EarningsByMonth', items: Array<{ __typename?: 'EarningsItem', label: string, total: number, unit: string, exclusivePosts?: { __typename?: 'EarningsByProductSummary', count: number, total: number } | null, subscriptions?: { __typename?: 'EarningsByProductSummary', count: number, total: number } | null, tips?: { __typename?: 'EarningsByProductSummary', count: number, total: number } | null, messages?: { __typename?: 'EarningsByProductSummary', total: number, count: number } | null }> } } } };

export type FeedQueryVariables = Exact<{
  type: FeedType;
  feedOpts?: InputMaybe<PaginationOptions>;
}>;


export type FeedQuery = { __typename?: 'Query', feed: { __typename?: 'PaginatedResult', hasNextPage: boolean, cursor?: string | null, items?: Array<{ __typename?: 'Comment' } | { __typename?: 'NSFWSubscription' } | { __typename?: 'Notification' } | { __typename?: 'Order' } | { __typename: 'Post', type: PostType, postId: string, isVisible: boolean, description?: string | null, likeCount: number, profileId: string, isLiked: boolean, publishedAt?: string | null, isSubscribed: boolean, isOwner: boolean, price?: number | null, commentCount: number, status: PostStatus, tags?: Array<{ __typename?: 'Tag', key: TagKey, slug: string, tagId: string, value: string }> | null, profile?: { __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null } | null, asset?: Array<{ __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, originalWidth: number, originalHeight: number, aspectRatio: number } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number } }> | null } | { __typename?: 'Profile' } | { __typename?: 'Referral' } | { __typename?: 'Tag' }> | null } };

export type IsEmailAvailableQueryVariables = Exact<{
  input: IsEmailAvailableInput;
}>;


export type IsEmailAvailableQuery = { __typename?: 'Query', isEmailAvailable: boolean };

export type IsUsernameAvailableQueryVariables = Exact<{
  input: IsUsernameAvailableInput;
}>;


export type IsUsernameAvailableQuery = { __typename?: 'Query', isUsernameAvailable: boolean };

export type IsUsernameValidQueryVariables = Exact<{
  input: IsUsernameValidInput;
}>;


export type IsUsernameValidQuery = { __typename?: 'Query', isUsernameValid: { __typename?: 'IsValidUsernameResult', isValid: boolean, invalidCharacters?: Array<string> | null } };

export type IsVerificationValidQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type IsVerificationValidQuery = { __typename?: 'Query', isVerificationValid: boolean };

export type ListUnconfiguredPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUnconfiguredPlansQuery = { __typename?: 'Query', listUnconfiguredPlans: Array<{ __typename: 'PlanOption', id: string, title: string, interval: Interval, duration: number }> };

export type ViewPostCommentsQueryVariables = Exact<{
  postId: Scalars['String']['input'];
  options: PaginationOptions;
}>;


export type ViewPostCommentsQuery = { __typename?: 'Query', viewPost: { __typename?: 'Post', comments: { __typename?: 'PaginatedResult', hasNextPage: boolean, cursor?: string | null, items?: Array<{ __typename: 'Comment', commentId: string, createdBy: string, createdAt: string, text: string, postId: string, author: { __typename?: 'Profile', displayName: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null } } | { __typename?: 'NSFWSubscription' } | { __typename?: 'Notification' } | { __typename?: 'Order' } | { __typename?: 'Post' } | { __typename?: 'Profile' } | { __typename?: 'Referral' } | { __typename?: 'Tag' }> | null } } };

export type OnboardingPartsFragment = { __typename?: 'AccountMetadata', onboarding: { __typename: 'CreatorOnboarding', setupMessaging: boolean, updatedBio: boolean, uploadedAvatar: boolean, createdSubscriptionPlan: boolean, uploadedFirstPost: boolean, firstWithdrawal: boolean, approvals: Array<{ __typename?: 'Approval', uid: string, approvalStatus: ApprovalStatus, createdAt: string, applicationUrl: string, requestedAt?: string | null, approvalId: string, provider: string }> } | { __typename: 'FanOnboarding', hasLinkedWallet: boolean, uploadedAvatar: boolean, updatedBio: boolean, firstLike: boolean, firstFollow: boolean, firstTip: boolean, firstExclusivePost: boolean, firstSubscription: boolean } };

export type QueryMeOnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryMeOnboardingQuery = { __typename?: 'Query', me: { __typename?: 'Account', metadata: { __typename?: 'AccountMetadata', onboarding: { __typename: 'CreatorOnboarding', setupMessaging: boolean, updatedBio: boolean, uploadedAvatar: boolean, createdSubscriptionPlan: boolean, uploadedFirstPost: boolean, firstWithdrawal: boolean, approvals: Array<{ __typename?: 'Approval', uid: string, approvalStatus: ApprovalStatus, createdAt: string, applicationUrl: string, requestedAt?: string | null, approvalId: string, provider: string }> } | { __typename: 'FanOnboarding', hasLinkedWallet: boolean, uploadedAvatar: boolean, updatedBio: boolean, firstLike: boolean, firstFollow: boolean, firstTip: boolean, firstExclusivePost: boolean, firstSubscription: boolean } } } };

export type QueryReferralsQueryVariables = Exact<{
  options?: InputMaybe<PaginationOptions>;
}>;


export type QueryReferralsQuery = { __typename?: 'Query', me: { __typename?: 'Account', referrals?: { __typename?: 'PaginatedResult', hasNextPage: boolean, cursor?: string | null, items?: Array<{ __typename?: 'Comment' } | { __typename?: 'NSFWSubscription' } | { __typename?: 'Notification' } | { __typename?: 'Order' } | { __typename?: 'Post' } | { __typename?: 'Profile' } | { __typename: 'Referral', referralId: string, type: string, status: string, rewards?: string | null, startedAt: string, rewardAddress?: string | null, rewardAmountUSD: string, transactionHash?: string | null, completedAt?: string | null, profile: { __typename?: 'Profile', username: string, displayName: string, avatar?: { __typename?: 'ImageAsset', url: string } | null } } | { __typename?: 'Tag' }> | null } | null } };

export type QueryMeSubscribersListQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryMeSubscribersListQuery = { __typename?: 'Query', me: { __typename?: 'Account', metadata: { __typename?: 'AccountMetadata', subscribedProfiles: Array<string> } } };

export type QueryMessagePacksQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryMessagePacksQuery = { __typename?: 'Query', messagePacks: Array<{ __typename: 'MessagePack', messagePackId: string, description?: string | null, credits: number, title: string }> };

export type MySubscriptionsQueryVariables = Exact<{
  filter?: InputMaybe<SubscriptionStatusFilter>;
  options: PaginationOptions;
}>;


export type MySubscriptionsQuery = { __typename?: 'Query', mySubscriptions: { __typename?: 'PaginatedResult', hasNextPage: boolean, cursor?: string | null, items?: Array<{ __typename?: 'Comment' } | { __typename: 'NSFWSubscription', createdAt: string, expiresAt: string, status: SubscriptionStatus, plan: { __typename?: 'Plan', planId: string, description: string, interval: Interval, duration: number, price: number, colour: string }, creator?: { __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null } | null, order: { __typename: 'Order', orderId: string, price: string, chainId: number, recipient: string, status: OrderStatus, createdAt: any, currencyCode: string, total: string, token: { __typename?: 'CryptoCurrency', symbol: TokenSymbol }, modifers?: Array<{ __typename: 'PlatformFee', unit: string, key: string, label: string, value: number }> | null } } | { __typename?: 'Notification' } | { __typename?: 'Order' } | { __typename?: 'Post' } | { __typename?: 'Profile' } | { __typename?: 'Referral' } | { __typename?: 'Tag' }> | null } };

export type QueryNonceQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryNonceQuery = { __typename?: 'Query', nonce: string };

export type QueryNotificationsQueryVariables = Exact<{
  options?: InputMaybe<PaginationOptions>;
}>;


export type QueryNotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'PaginatedResult', cursor?: string | null, hasNextPage: boolean, items?: Array<{ __typename?: 'Comment' } | { __typename?: 'NSFWSubscription' } | { __typename?: 'Notification', notificationId: string, title: string, userId: string, notificationType: NotificationType, createdAt: string, postId?: string | null, isRead: boolean, paymentAmount?: string | null, paymentProductType?: ProductType | null, paymentCurrency?: string | null, withdrawalAmount?: string | null, withdrawalTxn?: string | null, withdrawalCurrency?: string | null, post?: { __typename?: 'Post', asset?: Array<{ __typename?: 'PostAsset', media: { __typename: 'ImageAsset', url: string } | { __typename: 'VideoAsset', url: string } }> | null } | null, actor?: { __typename?: 'Profile', accountType: AccountType, profileId: string, username: string, displayName: string, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null } | { __typename?: 'Order' } | { __typename?: 'Post' } | { __typename?: 'Profile' } | { __typename?: 'Referral' } | { __typename?: 'Tag' }> | null } };

export type UnreadNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationsCountQuery = { __typename?: 'Query', unreadNotificationsCount: number };

export type ProfileCardWithFollowersQueryVariables = Exact<{
  username?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<PaginationOptions>;
}>;


export type ProfileCardWithFollowersQuery = { __typename?: 'Query', viewProfile: { __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, followersCount: number, activeSubscriberCount: number, followingCount: number, postsCount: number, followers?: { __typename?: 'PaginatedResult', hasNextPage: boolean, cursor?: string | null, items?: Array<{ __typename?: 'Comment' } | { __typename?: 'NSFWSubscription' } | { __typename?: 'Notification' } | { __typename?: 'Order' } | { __typename?: 'Post' } | { __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null } | { __typename?: 'Referral' } | { __typename?: 'Tag' }> | null } | null, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null } };

export type ProfileFollowersQueryVariables = Exact<{
  username?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<PaginationOptions>;
}>;


export type ProfileFollowersQuery = { __typename?: 'Query', viewProfile: { __typename?: 'Profile', followers?: { __typename?: 'PaginatedResult', hasNextPage: boolean, cursor?: string | null, items?: Array<{ __typename?: 'Comment' } | { __typename?: 'NSFWSubscription' } | { __typename?: 'Notification' } | { __typename?: 'Order' } | { __typename?: 'Post' } | { __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null } | { __typename?: 'Referral' } | { __typename?: 'Tag' }> | null } | null } };

export type ProfileFollowingQueryVariables = Exact<{
  username?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<PaginationOptions>;
}>;


export type ProfileFollowingQuery = { __typename?: 'Query', viewProfile: { __typename?: 'Profile', following?: { __typename?: 'PaginatedResult', hasNextPage: boolean, cursor?: string | null, items?: Array<{ __typename?: 'Comment' } | { __typename?: 'NSFWSubscription' } | { __typename?: 'Notification' } | { __typename?: 'Order' } | { __typename?: 'Post' } | { __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null } | { __typename?: 'Referral' } | { __typename?: 'Tag' }> | null } | null } };

export type ViewSalesQueryQueryVariables = Exact<{
  options?: InputMaybe<PaginationOptions>;
}>;


export type ViewSalesQueryQuery = { __typename?: 'Query', sales: { __typename?: 'PaginatedResult', hasNextPage: boolean, cursor?: string | null, items?: Array<{ __typename?: 'Comment' } | { __typename?: 'NSFWSubscription' } | { __typename?: 'Notification' } | { __typename: 'Order', orderId: string, price: string, chainId: number, recipient: string, status: OrderStatus, createdAt: any, currencyCode: string, total: string, customer?: { __typename?: 'Profile', profileId: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null, products: Array<{ __typename: 'DonationProduct', type: ProductType, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null } | { __typename: 'ExclusivePostProduct', type: ProductType, post?: { __typename?: 'Post', postId: string, description?: string | null, asset?: Array<{ __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, originalWidth: number, originalHeight: number, aspectRatio: number } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number } }> | null } | null, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null } | { __typename: 'MessagePackProduct', type: ProductType, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null, pack?: { __typename?: 'MessagePack', messagePackId: string, credits: number, title: string, description?: string | null } | null } | { __typename: 'SubscriptionProduct', type: ProductType, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null, plan: { __typename?: 'Plan', interval: Interval, duration: number }, subscription?: { __typename?: 'NSFWSubscription', createdAt: string, expiresAt: string } | null } | { __typename: 'TipProduct', type: ProductType, post?: { __typename?: 'Post', postId: string, description?: string | null, asset?: Array<{ __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, originalWidth: number, originalHeight: number, aspectRatio: number } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number } }> | null } | null, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null } | { __typename: 'WithdrawalProduct', type: ProductType, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null }>, token: { __typename?: 'CryptoCurrency', symbol: TokenSymbol }, modifers?: Array<{ __typename: 'PlatformFee', unit: string, key: string, label: string, value: number }> | null } | { __typename?: 'Post' } | { __typename?: 'Profile' } | { __typename?: 'Referral' } | { __typename?: 'Tag' }> | null } };

export type ScheduledPostsQueryVariables = Exact<{
  paginationOpts?: InputMaybe<PaginationOptions>;
}>;


export type ScheduledPostsQuery = { __typename?: 'Query', scheduledPosts: { __typename?: 'PaginatedResult', hasNextPage: boolean, cursor?: string | null, items?: Array<{ __typename?: 'Comment' } | { __typename?: 'NSFWSubscription' } | { __typename?: 'Notification' } | { __typename?: 'Order' } | { __typename?: 'Post', type: PostType, postId: string, isVisible: boolean, description?: string | null, likeCount: number, profileId: string, isLiked: boolean, publishedAt?: string | null, isSubscribed: boolean, isOwner: boolean, price?: number | null, commentCount: number, status: PostStatus, profile?: { __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null } | null, asset?: Array<{ __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, originalWidth: number, originalHeight: number, aspectRatio: number } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number } }> | null } | { __typename?: 'Profile' } | { __typename?: 'Referral' } | { __typename?: 'Tag' }> | null } };

export type SearchQueryVariables = Exact<{
  options?: InputMaybe<PaginationOptions>;
  query: Scalars['String']['input'];
}>;


export type SearchQuery = { __typename?: 'Query', search: { __typename?: 'PaginatedResult', cursor?: string | null, hasNextPage: boolean, items?: Array<{ __typename?: 'Comment' } | { __typename?: 'NSFWSubscription' } | { __typename?: 'Notification' } | { __typename?: 'Order' } | { __typename?: 'Post' } | { __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null } | { __typename?: 'Referral' } | { __typename?: 'Tag' }> | null } };

export type SeasonOneReferralsQueryVariables = Exact<{ [key: string]: never; }>;


export type SeasonOneReferralsQuery = { __typename?: 'Query', seasonOneReferrals: { __typename?: 'SeasonReferrals', rewardsTotal: string, rewardsRemaining: string } };

export type QuerySuggestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type QuerySuggestionsQuery = { __typename?: 'Query', suggestions: Array<{ __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null }> };

export type TagsQueryVariables = Exact<{
  input: TagFilter;
  options?: InputMaybe<PaginationOptions>;
}>;


export type TagsQuery = { __typename?: 'Query', tags: { __typename?: 'PaginatedResult', cursor?: string | null, hasNextPage: boolean, items?: Array<{ __typename?: 'Comment' } | { __typename?: 'NSFWSubscription' } | { __typename?: 'Notification' } | { __typename?: 'Order' } | { __typename?: 'Post' } | { __typename?: 'Profile' } | { __typename?: 'Referral' } | { __typename?: 'Tag', slug: string, tagId: string, key: TagKey, value: string }> | null } };

export type ViewCreatorPlansQueryVariables = Exact<{
  creatorId: Scalars['String']['input'];
}>;


export type ViewCreatorPlansQuery = { __typename?: 'Query', viewCreatorPlans: Array<{ __typename?: 'Plan', planId: string, description: string, title: string, price: number, interval: Interval, duration: number }> };

export type ViewOrderQueryQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type ViewOrderQueryQuery = { __typename?: 'Query', viewOrder: { __typename?: 'Order', orderId: string, chainId: number, status: OrderStatus, signer: string, recipient: string, currencyCode: string, total: string, createdAt: any, customer?: { __typename?: 'Profile', profileId: string, displayName: string } | null, token: { __typename?: 'CryptoCurrency', symbol: TokenSymbol, contract: string }, payments: Array<{ __typename: 'CryptoPayment', paymentId: string, status: PaymentStatus, transactionHash?: string | null, signer: string, recipient: string, createdAt: any, completedAt?: any | null, token: { __typename?: 'CryptoCurrency', symbol: TokenSymbol, contract: string } }> } };

export type ViewPostWithCommentsQueryVariables = Exact<{
  postId: Scalars['String']['input'];
  options?: InputMaybe<PaginationOptions>;
}>;


export type ViewPostWithCommentsQuery = { __typename?: 'Query', viewPost: { __typename?: 'Post', type: PostType, postId: string, isVisible: boolean, description?: string | null, likeCount: number, profileId: string, isLiked: boolean, publishedAt?: string | null, isSubscribed: boolean, isOwner: boolean, price?: number | null, commentCount: number, status: PostStatus, comments: { __typename?: 'PaginatedResult', hasNextPage: boolean, cursor?: string | null, items?: Array<{ __typename: 'Comment', commentId: string, createdBy: string, createdAt: string, text: string, postId: string, author: { __typename?: 'Profile', displayName: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null } } | { __typename?: 'NSFWSubscription' } | { __typename?: 'Notification' } | { __typename?: 'Order' } | { __typename?: 'Post' } | { __typename?: 'Profile' } | { __typename?: 'Referral' } | { __typename?: 'Tag' }> | null }, profile?: { __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null } | null, asset?: Array<{ __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, originalWidth: number, originalHeight: number, aspectRatio: number } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number } }> | null } };

export type ViewProfileQueryVariables = Exact<{
  username?: InputMaybe<Scalars['String']['input']>;
  postFilter?: InputMaybe<PostFilter>;
  postOptions?: InputMaybe<PaginationOptions>;
}>;


export type ViewProfileQuery = { __typename?: 'Query', viewProfile: { __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, followersCount: number, activeSubscriberCount: number, followingCount: number, postsCount: number, tags: Array<{ __typename?: 'Tag', tagId: string, value: string, key: TagKey, slug: string }>, posts: { __typename: 'PaginatedResult', cursor?: string | null, hasNextPage: boolean, items?: Array<{ __typename?: 'Comment' } | { __typename?: 'NSFWSubscription' } | { __typename?: 'Notification' } | { __typename?: 'Order' } | { __typename: 'Post', type: PostType, postId: string, isVisible: boolean, description?: string | null, likeCount: number, profileId: string, isLiked: boolean, publishedAt?: string | null, isSubscribed: boolean, isOwner: boolean, price?: number | null, commentCount: number, status: PostStatus, profile?: { __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null } | null, asset?: Array<{ __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, fallbackUrl: string, originalWidth: number, originalHeight: number, aspectRatio: number, formats?: Array<{ __typename?: 'ResizedAsset', format: ResizedAssetFormat, url: string, fallbackUrl: string, width?: number | null, height?: number | null }> | null } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number, formats?: Array<{ __typename?: 'ResizedAsset', format: ResizedAssetFormat, url: string, fallbackUrl: string, width?: number | null, height?: number | null }> | null } }> | null } | { __typename?: 'Profile' } | { __typename?: 'Referral' } | { __typename?: 'Tag' }> | null }, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null } };

export type ViewProfilePostsQueryVariables = Exact<{
  profileId: Scalars['String']['input'];
  postFilter?: InputMaybe<PostFilter>;
  postOptions?: InputMaybe<PaginationOptions>;
}>;


export type ViewProfilePostsQuery = { __typename?: 'Query', viewProfile: { __typename?: 'Profile', posts: { __typename: 'PaginatedResult', cursor?: string | null, hasNextPage: boolean, items?: Array<{ __typename?: 'Comment' } | { __typename?: 'NSFWSubscription' } | { __typename?: 'Notification' } | { __typename?: 'Order' } | { __typename: 'Post', type: PostType, postId: string, isVisible: boolean, description?: string | null, likeCount: number, profileId: string, isLiked: boolean, publishedAt?: string | null, isSubscribed: boolean, isOwner: boolean, price?: number | null, commentCount: number, status: PostStatus, profile?: { __typename: 'Profile', accountType: AccountType, bio?: string | null, displayName: string, profileId: string, isFollowing: boolean, referralUrl: string, username: string, avatar?: { __typename?: 'ImageAsset', url: string } | null, messaging?: { __typename?: 'MessageSettings', rate?: number | null, unit?: string | null, audience?: Audience | null } | null } | null, asset?: Array<{ __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, fallbackUrl: string, originalWidth: number, originalHeight: number, aspectRatio: number, formats?: Array<{ __typename?: 'ResizedAsset', format: ResizedAssetFormat, url: string, fallbackUrl: string, width?: number | null, height?: number | null }> | null } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number, formats?: Array<{ __typename?: 'ResizedAsset', format: ResizedAssetFormat, url: string, fallbackUrl: string, width?: number | null, height?: number | null }> | null } }> | null } | { __typename?: 'Profile' } | { __typename?: 'Referral' } | { __typename?: 'Tag' }> | null } } };

export type ViewOrdersQueryQueryVariables = Exact<{
  filter?: InputMaybe<OrderFilter>;
  options?: InputMaybe<PaginationOptions>;
}>;


export type ViewOrdersQueryQuery = { __typename?: 'Query', orders: { __typename?: 'PaginatedResult', hasNextPage: boolean, cursor?: string | null, items?: Array<{ __typename?: 'Comment' } | { __typename?: 'NSFWSubscription' } | { __typename?: 'Notification' } | { __typename: 'Order', orderId: string, price: string, chainId: number, recipient: string, status: OrderStatus, createdAt: any, currencyCode: string, total: string, products: Array<{ __typename: 'DonationProduct', type: ProductType, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null } | { __typename: 'ExclusivePostProduct', type: ProductType, post?: { __typename?: 'Post', postId: string, description?: string | null, asset?: Array<{ __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, originalWidth: number, originalHeight: number, aspectRatio: number } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number } }> | null } | null, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null } | { __typename: 'MessagePackProduct', type: ProductType, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null, pack?: { __typename?: 'MessagePack', messagePackId: string, credits: number, title: string, description?: string | null } | null } | { __typename: 'SubscriptionProduct', type: ProductType, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null, plan: { __typename?: 'Plan', interval: Interval, duration: number }, subscription?: { __typename?: 'NSFWSubscription', createdAt: string, expiresAt: string } | null } | { __typename: 'TipProduct', type: ProductType, post?: { __typename?: 'Post', postId: string, description?: string | null, asset?: Array<{ __typename?: 'PostAsset', ordinal: number, media: { __typename: 'ImageAsset', url: string, originalWidth: number, originalHeight: number, aspectRatio: number } | { __typename: 'VideoAsset', url: string, fallbackUrl: string, duration?: number | null, originalWidth: number, originalHeight: number, aspectRatio: number } }> | null } | null, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null } | { __typename: 'WithdrawalProduct', type: ProductType, creator?: { __typename?: 'Profile', displayName: string, username: string, bio?: string | null, avatar?: { __typename?: 'ImageAsset', url: string } | null } | null }>, payments: Array<{ __typename?: 'CryptoPayment', paymentId: string, transactionHash?: string | null, status: PaymentStatus, createdAt: any, completedAt?: any | null, recipient: string, token: { __typename?: 'CryptoCurrency', symbol: TokenSymbol } }>, token: { __typename?: 'CryptoCurrency', symbol: TokenSymbol }, modifers?: Array<{ __typename: 'PlatformFee', unit: string, key: string, label: string, value: number }> | null } | { __typename?: 'Post' } | { __typename?: 'Profile' } | { __typename?: 'Referral' } | { __typename?: 'Tag' }> | null } };
